<template>
    <div>
        <h1 v-if="!data.result.id" class="view-title">
			NOVO ROTEIRO
            <a class="btn btn-link btn-right" :href="root_url + '/download/deliveryb2b_help.pdf'" target="_blank">
                <i class="fas fa-file-pdf"></i> ABRIR TUTORIAL
            </a>
            <button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-right: 5px;">
                <i class="fas fa-question-circle"></i> TOUR
            </button>
		</h1>
        <h1 v-if="data.result.id" class="view-title">
			{{ data.base.name }} - {{ getDate(data.base.date) }}
            <a class="btn btn-link btn-right" :href="root_url + '/download/deliveryb2b_help.pdf'" target="_blank">
                <i class="fas fa-file-pdf"></i> ABRIR TUTORIAL
            </a>
            <button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-right: 5px;">
                <i class="fas fa-question-circle"></i> TOUR
            </button>
		</h1>
        <div class="inner-content">
            <div class="row">
                <div class="col-xs-12 col-lg-12 container-top">
                    <div class="container-itinerary"  data-v-step-routing-map="1">
                        <RoutingCardSummary
                            :name="data.base.name"
                            :date="data.base.date"
                            :totalRoute="totalRoute"
                            :totalDelivery="totalDelivery"
                            :totalDistance="totalDistance"
                            :totalWeight="totalWeight"
                            :totalDroppedNode="totalDroppedNode"
                            :currentJourney="currentJourney"
                            :currentSummary="currentSummary"
                            :default_moviment_type_code="my_settings.default_moviment_type_code"
                            @onMouseOverInstruction="onMouseOverInstruction"
                            @onMouseOutInstruction="onMouseOutInstruction"
                            @removeCurrent="removeCurrentJourney"
                            ref="cardSummary"
                        />
                    </div>
                    <div id="map" class="map container-map shadowed" ref="map" :style="((currentJourney != null) ? 'margin-top: -440px' : 'margin-top: -137px')"  data-v-step-routing-map="0"></div>
                </div>
                <div class="col-xs-12 col-lg-12">
                    <div class="container-route shadowed"  data-v-step-routing-map="2">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12 collapse-header" @click="showRoute = !showRoute">
                                <div class="container-collapse-header">
                                    <span><b><i class="fa fa=fw fa-route"></i> Rotas geradas ({{ journeyWithRouteList.length }})</b></span> 
                                    <span v-popover:tooltip.right="'Lista dos veículos com e sem rotas definidas após processamento'" style="margin-left: 5px"><i class="fas fa-question-circle"></i></span>
                                    <span class="collapse-header-arrow" v-if="showRoute"><i class="fa fa-chevron-up"></i></span>
                                    <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-lg-12 collapse-body" :style="'display: ' + (showRoute ? 'block' : 'none')">
                                <div class="container-collapse-body">
                                    <RoutingTableSummary 
                                        :headers="headers" 
                                        :list="journeyWithRouteList"
                                        :list2="journeyWithoutRouteList"
                                        :modifiers="modifiersWithRoute"
                                        :modifiers2="modifiersWithoutRoute"
                                        :select_all="selectAll" 
                                        :on_select="onSelect"
                                        :selected="selectedJourneyWithRouteList"
                                        :set_current_journey="setCurrentJourney"
                                        :edit_journey="setEditCurrentJourney"
                                        :edit_journey_color="setEditCurrentJourneyColor"
                                        :select_driver="my_drivers"
                                        :has_options="true"
                                        :is_dropped="false"
                                        :sequence_journey="setSequenceCurrentJourney"
                                        :finished="finished"
                                        ref="route"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="droppedNodesList.length > 0" class="col-xs-12 col-lg-12">
                    <div class="container-dropped shadowed">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12 collapse-header" @click="showDropped = !showDropped">
                                <div class="container-collapse-header">
                                    <span><b><i class="fa fa-fw fa-boxes"></i> Entregas desvinculadas ({{ droppedNodesList.length }})</b></span> 
                                    <span v-popover:tooltip.right="'Lista das entregas que ficaram sem vinculo definido com veículo após processamento'" style="margin-left: 5px"><i class="fas fa-question-circle"></i></span>
                                    <span class="collapse-header-arrow" v-if="showDropped"><i class="fa fa-chevron-up"></i></span>
                                    <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-lg-12 collapse-body" :style="'display: ' + (showDropped ? 'block' : 'none')">
                                <div class="container-collapse-body">
                                    <RoutingTableSummary 
                                        :headers="headersDropped"
                                        :list="droppedNodesList"
                                        :list2="[]"
                                        :modifiers="modifiersDropped"
                                        :select_all="selectAll"
                                        :on_select="onSelect"
                                        :selected="selectedDroppedNodesList"
                                        :has_options="false"
                                        :is_dropped="true"
                                        ref="dropped_node"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-lg-12">
                    <div class="container-button">
                        <div class="row">
                            <div class="col-xs-12 col-lg-12">
                                <button v-if="!data.result.id" class="button-edit button-cancel" @click="cancel">
                                    <i class="fa fa-fw fa-times"></i> CANCELAR
                                </button>
                                <button v-if="data.result.id" class="button-edit button-cancel" @click="back">
                                    <i class="fa fa-fw fa-caret-left"></i> VOLTAR A LISTA
                                </button>
                                <button v-if="(journeyWithRouteList.length > 0)" class="button-edit" :disabled="loading || finished" @click="save" data-v-step-routing-map="3">
                                    <i :class="'fa fa-fw' + (loading ? ' fa-circle-notch fa-spin' : ' fa-save')"></i> SALVAR
                                </button>
                                <button v-if="(journeyWithRouteList.length > 0)" class="button-edit button-finish" :disabled="loading || finished" @click="finish" data-v-step-routing-map="4">
                                    <i :class="'fa fa-fw' + (loading ? ' fa-circle-notch fa-spin' : ' fa-check')"></i> FINALIZAR
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <RoutingModalEdit v-if="showModalEditJourney" 
            :journey="editCurrentJourney"
            :journeyIndex="editCurrentJourneyIndex"
            :journeyHasRoute="editCurrentJourneyHasRoute"
            :droppedNodes="droppedNodesList"
            :client_atak="client_atak"
            :default_moviment_type_code="my_settings.default_moviment_type_code"
            @close="removeEditCurrentJourney"
            @routing="updateJourneyEdited"
            ref="modalEdit"
        />

        <RoutingModalSequence v-if="showModalSequenceJourney" 
            :journey="sequenceCurrentJourney"
            :journeyIndex="sequenceCurrentJourneyIndex"
            :client_atak="client_atak"
            :default_moviment_type_code="my_settings.default_moviment_type_code"
            @close="removeSequenceCurrentJourney"
            @updating="updateSequence"
            ref="modalSequence"
        />

        <RoutingModalSynchronizationAtak v-if="showModalSynchronizationAtak"
            :current="current"
            :my_drivers="my_drivers"
            :my_courses="my_courses"
            :integration="my_settings.integration"
            :url_api_atak="my_settings.url_api_atak"
            :default_driver_code="my_settings.default_driver_code"
            :default_shipping_company_code="my_settings.default_shipping_company_code"
            @close="closeSynchronizationAtak"
        />

        <Tour
            tour="DeliveryRouting"
            :steps="tour_steps"
            :callbackOnFinish="true"
			ref="tour"
        />
    </div>
</template>

<script>
// Components
import $ from "jquery";
import Api from "@/lib/Api";
import L from "leaflet";
import RoutingCardSummary from "../Routing/RoutingCardSummary";
import RoutingModalEdit from "../Routing/RoutingModalEdit";
import RoutingModalSequence from "../Routing/RoutingModalSequence";
import RoutingModalSynchronizationAtak from "../Routing/RoutingModalSynchronizationAtak";
import RoutingTableSummary from "../Routing/RoutingTableSummary";
import Tour from "../../components/Tour";

// CSS
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.js";

const attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
const osmUrl = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";

export default {
    name: "RoutingMap",

    props: {
        data: {
            type: Object,
            require: true,
        },
        my_drivers: {
            type: Array,
            require: true,
        },
        my_settings: {
            type: Object,
            require: true,
        },
        my_courses: {
            type: Array,
            require: true,
        },
    },

    components: {
        RoutingCardSummary,
        RoutingModalEdit,
        RoutingModalSequence,
        RoutingModalSynchronizationAtak,
        RoutingTableSummary,
        Tour,
    },

	data: function() {
		return {
            root_url: this.$api.config.B2B_ROOT_URL,
			loading: false,
            totalRoute: 0,
            totalDelivery: 0,
            totalDroppedNode: 0,
            totalDistance: 0,
            totalTime: 0,
            totalWeight: 0,

            allowUpdate: true,
            
            // dados do mapa
            map: null,
            center: null,
            zoom: null,

            // Define o servidor de roteirização
            router: new L.Routing.OSRMv1({
                serviceUrl: this.$api.config.B2B_ROOT_URL_API_TRACER,
                //serviceUrl: 'http://192.168.1.85/route/v1',
                profile: 'driving',
                timeout: 30000,
                routingOptions: {
                    alternatives: false,
                    steps: true
                },
                useHints: true,
                suppressDemoServerWarning: false,
                language: 'pt-BR'
            }),
            
            // Dados dos veículos com rotas
            journeyWithRouteList: [],
            selectedJourneyWithRouteList: [],
            markerJourneyWithRouteList: [],
            controlJourneyWithRouteList: [],
            
            // Dados dos veículos sem rotas
            journeyWithoutRouteList: [],
            
            // Dados dos nós desvinculados
            droppedNodesList: [],
            selectedDroppedNodesList: [],
            markerDroppedNodeList: [],
            layerGroupDroppedNode: null,
            
            // Dados das tabelas
            headers: {
				vehicleLicensePlate: "Placa",
                totalDelivery: "Entregas",
                constraints: "Restrições",
                percentWeight: "Capacidade",
                percentTime: "Tempo",
				totalDistance: "Distância",
                totalWeight: "Peso",
			},
            headersDropped: {
				documentNumber: "Número",
				customerName: "Cliente",
                address: "Endereço",
                weight: "Peso"
			},
            modifiersWithRoute: {
                constraints: function(d, item) {
                    let weight = "<span title='" + (item.weightConstraints ? 'Ligado' : 'Desligado') + "'><i class='" + (item.weightConstraints ? 'fas fa-fw fa-check-square' : 'far fa-fw fa-square') + "'></i> Peso</span>";
                    let time = "<span title='" + (item.timeConstraints ? 'Ligado' : 'Desligado') + "'><i class='" + (item.timeConstraints ? 'fas fa-fw fa-check-square' : 'far fa-fw fa-square') + "'></i> Tempo</span>";
                    return weight + " " + time;
                },

                percentWeight: function(d, item) {
                    let capacity = 0.0;

                    if(item.totalWeight) {
                        capacity = (item.totalWeight * 100) / item.vehicleWeightCapacity;
                        if (typeof capacity !== 'number') capacity = 0.0;
                        capacity = (capacity % 10) != 0 ? capacity.toFixed(1) : capacity;
                    } else {
                        capacity = "0.0";
                    }
                    if ((capacity == "NAN") || (capacity == "Infinity")) capacity = "0.0";
                    
                    let backgroundColor = "";
                    let borderColor = "";
                    let percentage = parseInt(capacity) > 100 ? 100 : parseInt(capacity);
                    if(percentage <= 50) {
                        backgroundColor = "#64ff64";
                        borderColor = "#0dac0d";
                    } else if((percentage > 50) && (percentage < 90)) {
                        backgroundColor = "#ffc965";
                        borderColor = "#b77c10";
                    } else {
                        backgroundColor = "#faa";
                        borderColor = "#f55";
                    }

                    let style = "display: block; width: 60px; border: 1px solid " + borderColor + "; font-size: 11px; text-align: center; background: linear-gradient(90deg, " + backgroundColor + " " + percentage + "%, white " + percentage + "%)";

                    return "<span title='" + capacity + " %' style='" + style + "'>" + capacity + " %</span>";
                },

                percentTime: function(d, item) {
                    let time = 0.0;
                    
                    if (item.totalTime) {
                        time = (item.totalTime * 100) / item.totalTimeHour;
                        if (typeof time !== 'number') time = 0.0;
                        time = (time % 10) != 0 ? time.toFixed(1) : time;
                    } else {
                        time = "0.0";
                    }

                    if ((time == "NAN") || (time == "Infinity")) time = "0.0";
                    
                    let backgroundColor = "";
                    let borderColor = "";
                    let percentage = parseInt(time) > 100 ? 100 : parseInt(time);
                    if(percentage < 50) {
                        backgroundColor = "#64ff64";
                        borderColor = "#0dac0d";
                    } else if((percentage > 50) && (percentage < 90)) {
                        backgroundColor = "#ffc965";
                        borderColor = "#b77c10";
                    } else {
                        backgroundColor = "#faa";
                        borderColor = "#f55";
                    }

                    let style = "display: block; width: 60px; border: 1px solid " + borderColor + "; font-size: 11px; text-align: center; background: linear-gradient(90deg, " + backgroundColor + " " + percentage + "%, white " + percentage + "%)";

                    return "<span title='" + time + " %' style='" + style + "'>" + time + " %</span>";
                },

                totalDistance: function(d) {
                    d = d / 1000;
                    d = d.toFixed(1).replace(".", ",");
                    return "<span title='" + d + " km'>" + d + " km</span>";
                },

                totalWeight: function(d) {
                    let weightFormated = "";

                    if(d < 1000)
                        weightFormated = d.toFixed(2) + " kg";
                    else
                        weightFormated = (d / 1000).toFixed(2) + " t";
                        
                    weightFormated = weightFormated.replace(".", ",");

                    return "<span title='" + weightFormated + "'>" + weightFormated + "</span>";
                },
            },
            modifiersWithoutRoute: {
                percentWeight: function() {
                    let style = "display: block; width: 60px; border: 1px solid #aaa; font-size: 11px; text-align: center; background-color: white";

                    return "<span title='0.0 %' style='" + style + "'>0.0 %</span>";
                },

                constraints: function() {
                    let weight = "<span title='Desligado'><i class='far fa-fw fa-square'></i> Peso</span>";
                    let time = "<span title='Desligado'><i class='far fa-fw fa-square'></i> Tempo</span>";
                    return weight + " " + time;
                },

                percentTime: function() {
                    let style = "display: block; width: 60px; border: 1px solid #aaa; font-size: 11px; text-align: center; background-color: white";

                    return "<span title='0.0 %' style='" + style + "'>0.0 %</span>";
                },

                totalDistance: function() {
                    return "<span title='0.0 km'>0.0 km</span>";
                },

                totalWeight: function() {
                    return "<span title='0.00 kg'>0.00 kg</span>";
                },
            },
            modifiersDropped: {
                address: function(d, item) {
                    let address = item.addressStreet + ", " + (item.addressNumber ? item.addressNumber : "")  + " - " + (item.addressNeighborhood ? item.addressNeighborhood : "") + ", " + item.addressCity + " - " + item.addressUf + " - " + item.addressPostalCode;
                    return "<span title='" + address + "'>" + address + "</span>";
                },

                weight: function(d) {
                    let weightFormated = "";

                    if(d < 1000)
                        weightFormated = d.toFixed(2) + " kg";
                    else
                        weightFormated = (d / 1000).toFixed(2) + " t";
                        
                    weightFormated = weightFormated.replace(".", ",");

                    return "<span title='" + weightFormated + "'>" + weightFormated + "</span>";
                },
            },

            showRoute: true,
            showDropped: true,
            
            currentJourney: null,
            currentJourneyIndex: null,
            currentSummary: 'route',

            showModalEditJourney: false,
            editCurrentJourney: null,
            editCurrentJourneyIndex: null,
            editCurrentJourneyHasRoute: false,
            
            showModalSequenceJourney: false,
            sequenceCurrentJourney: null,
            sequenceCurrentJourneyIndex: null,
            
            currentColorList: [],
            currentColorPosition: 0,
            
            driverWithRoute: [],
            driverMoreThanOneRoute: [],

            countRoute: 0,
            pointsWithZeroWeight: 0,
            saved: false,
            finished: false,

            client_atak: this.$api.user.company_client_atak,
            
            showModalSynchronizationAtak: false,
            token: false,
            current: null,

            tour_steps: [
                {
                    target: '[data-v-step-routing-map="0"]',
                    header: {
                        title: '<code>MAPA</code>',
                    },
                    content: '<code>Mapa de exibição das rotas e entregas processadas</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-map="1"]',
                    header: {
                        title: '<code>RESUMO</code>',
                    },
                    content: '<code>Exibe um breve resumo das principais informações do processamento do roteiro</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-map="2"]',
                    header: {
                        title: '<code>LISTAGENS</code>',
                    },
                    content: '<code>Mostra as listas de veículos e entregas processadas, informando de forma geral as capacidades, retrições e entregas sem vínculo definido</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-map="3"]',
                    header: {
                        title: '<code>SALVAR</code>',
                    },
                    content: '<code>Clique em <b>SALVAR</b> para salvar o roteiro gerado e poder editar posteriormente</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-map="4"]',
                    header: {
                        title: '<code>FINALIZAR</code>',
                    },
                    content: '<code>Clique em <b>FINALIZAR</b> para finalizar o roteiro gerado e definir entregas e veículos as cargas geradas <br/> <b>Atenção! Entregas finalizadas não irão mais aparecer para serem roteirizadas</b></code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
		}
	},

    created: function() {
        this.hideControlDivs(true);
    },

    mounted: function() {
        this.$refs.tour.setTour();
        this.processData();
        this.generateMap();
        //this.processDCNode();
        this.processDroppedNodes();
        this.processJourneys();
        this.verifyFinished();
    },

    updated: function() {
        // Atualiza a tabela
        this.$refs.route.update();
    },

    methods: {
        /**
         * Processa os dados obtidos pela API
         **/ 
        processData: function () {
            // Processa para cada item
            this.data.result.journeys.map(journey => {
                // Identifica veículos com pontos além do centro de distribuição 
                if(((!journey.returnOrigin) && (journey.points.length > 1)) || ((journey.returnOrigin) && (journey.points.length > 2))) {
                    journey.totalDelivery = journey.returnOrigin ? journey.points.length - 2 : journey.points.length - 1;
                    
                    journey = Object.assign({}, this.data.base.vehicles[journey.id], journey);
                    
                    journey.points = journey.points.map(point => {
                        return Object.assign({}, this.data.base.points[point.id], point);
                    });

                    this.journeyWithRouteList.push(journey);
                    this.selectedJourneyWithRouteList.push(journey); 
                } else {
                    journey.totalDelivery = 0;

                    journey = Object.assign({}, this.data.base.vehicles[journey.id], journey);
                    
                    journey.points = journey.points.map(point => {
                        return Object.assign({}, this.data.base.points[point.id], point);
                    });

                    this.journeyWithoutRouteList.push(journey);
                }
            });
            
            // Identifica os pontos inviáveis
            this.data.result.droppedNodes.map(droppedNode => {
                droppedNode = Object.assign({}, this.data.base.points[droppedNode.id], droppedNode);

                this.droppedNodesList.push(droppedNode);
                this.selectedDroppedNodesList.push(droppedNode);
            });

            // Verifica se já foi salvo ou finalizado
            if (!this.data.base.id) {
                // Feedback geral do processamento
                this.$notification.success("Otimização cargas e rotas concluída.");
            }
            // Feedback geral das rotas encontradas
            if (this.journeyWithRouteList.length > 0) {
                this.$notification.success("Total de rotas geradas: " + this.journeyWithRouteList.length + ".");
                this.$notification.success("Total de entregas vinculadas: " + this.totalDelivery + ".");
            } else {
                this.$notification.error("Infelizmente, com as restrições iniciais, não foi possível gerar rotas viáveis. Por favor, tente editar as entregas dos veículos.");
            }
            // Feedback geral dos pedidos desvinculádos.
            if (this.droppedNodesList.length > 0) {
                this.$notification.success("Total de entregas desvinculadas: " + this.droppedNodesList.length + ".");
            } else {   
                this.$notification.success("Total de entregas desvinculadas: 0.");
            }

            // Define o total de entregas
            this.totalRoute = this.journeyWithRouteList.length;
            this.totalDroppedNode = this.droppedNodesList.length;
        },

        /**
         * Gera o mapa com os marcadores
         **/ 
        generateMap: function() {
            // Define a coordenada do centro do mapa
            this.center = this.data.base.points[0].coordinates.split(",");
            // Define o zoom inicial do mapa
            this.zoom = 14;

            // Cria o mapa
            let map = new L.map(
                this.$refs.map, {
                    center: [this.center[0], this.center[1]],
                    zoom: this.zoom,
                    zoomControl: false
                }
            );
            
            // Define o servidor de busca das imagens do mapa
            let titleLayer = new L.tileLayer(
                osmUrl, {
                    attribution: attribution
                }
            );
            // Atribui o servidor ao mapa
            titleLayer.addTo(map);
            
            // Define um controle de zoom e sua posição
            let zoomControl = new L.control.zoom({
                position: 'topright'
            });
            // Atribui o controle ao mapa
            zoomControl.addTo(map);
            
            // Preenche o mapa
            this.map = map;
        },
        
        /**
         * Processa o ponto inicial e exibe no mapa
         **/ 
        processDCNode: function() {
            // Inicia o marcador do centro de distribuição
            let marker = null;

            // Processa a entrega
            marker = this.processNodeIndividual(this.data.base.points[0], 0, true, false);

            // Adiciona ao mapa
            marker.addTo(this.map);
        },

        /**
         * Processa as entregas devinculados e exibe no mapa
         **/ 
        processDroppedNodes: function() {
            // Verifica se foi retornada entregas desvinculadas
            if(this.droppedNodesList.length > 0) {
                // Pecorre a lista de pontos
                this.droppedNodesList.map((point, index) => {
                    // Inicia o marcador da entrega
                    let marker = null;

                    // Processa a entrega
                    marker = this.processNodeIndividual(point, index, false, true);

                    // Adicionar a lista de marcadores
                    this.markerDroppedNodeList.push(marker);
                });

                // Adiciona a lista de marcadores em uma layer group e a adiciona ao mapa
                this.layerGroupDroppedNode = L.layerGroup(this.markerDroppedNodeList).addTo(this.map);
            }
        },
        
        /**
         * Processa uma entrega individuamente e exibe o marcador no mapa
         * @param {object} point objeto com informações do ponto
         * @param {number} index índice da posição do marcador
         * @param {boolean} isDCNode se o ponto é Centro de Distribuição
         * @param {boolean} isDroppedNode se o ponto é da lista de dropped nodes
         * @return {object} marcador da entrega desvinculada
         **/ 
        processNodeIndividual: function(point, index, isDCNode, isDroppedNode) {
            // Inicia as coordenadas
            let pointCoordinates = point.coordinates.split(",");
            let pointLatLng = L.latLng(pointCoordinates[0], pointCoordinates[1]);

            // Define a cor do nó
            let color = this.getColor(true);
            
            // Define uma div como icone do marcador
            let divIcon = new L.divIcon({
                className: "customer-div-icon",
                html: this.getHtmlDivIcon(index, color, isDCNode, isDroppedNode),
                iconSize: [30, 30],
                iconAnchor: [15, 30],
                popupAnchor: [0, -30]
            });
            
            // Cria o marcador
            let marker = new L.marker(pointLatLng, {
                draggable: false,
                icon: divIcon,
            }).on("mouseover", function(e) {
                // Abre o popup quando o mouse passa por cima
                e.target.openPopup();
            }).on("mouseout", function(e) {
                // Fecha o popup quando mouse sai de cima
                e.target.closePopup();
            }).bindPopup(
                // Define o conteúdo do popup
                this.getHtmltPopup(point, isDCNode, isDroppedNode)
            );

            // Define a cor do ponto
            point.color = color;

            // Define o marcador do ponto
            point.objectMap = marker;
            
            // Retorna o marcado da entrega
            return marker;
        },
        
        /**
         * Processa as rotas e exibe no mapa
         **/ 
        processJourneys: function() {
            // Verifica se existem rotas
            if(this.journeyWithRouteList.length > 0) {
                // Processa a rota de cada veículo
                this.journeyWithRouteList.map(journey => {
                    // Processa o grupo control da rota
                    let control = this.processJourneyIndividual(journey);

                    // Adiciona o grupo de linha e marcadores na lista
                    this.controlJourneyWithRouteList.push(control);
                });
            }
        },

        /**
         * Processa uma rota individuamente e exibe a rota no Mapa
         * @param {object} journey objeto com informações da rota
         * @return {object} objeto do grupo de linha e marcadores da rota
         **/
        processJourneyIndividual: function(journey) {
            // Define as funções localmente
            let getHtmlDivIcon = this.getHtmlDivIcon;
            let getHtmltPopup = this.getHtmltPopup;
            let processJourneysTimeAndHours = this.processJourneysTimeAndHours;
            let processDistanceAndTime = this.processDistanceAndTime;
            let notification = this.$notification;
            
            // Processa os pontos
            let result = this.processWaypoints(journey.points);

            // Determina a lista de pontos
            let waypoints = result[0];
            // Determina os pontos de parada
            let indexs = result[1];
            
            // Inicia a cor da rota e pontos
            let color = "";

            // Verifica se a rota já tem cor
            if(journey.color) {
                // Determina a cor da rota e pontos
                color = journey.color;
            } else {
                // Determina a cor da rota e pontos
                color = this.getColor(false);

                // Define a cor da rota
                journey.color = color;
            }
            
            // Define o plan do control
            let plan = new L.Routing.plan(waypoints, {
                addWaypoints: false,
                draggableWaypoints: false,
                routeWhileDragging: false,
                createMarker: function (index, waypoint, total) {
                    // Define uma div como icone do marcador
                    let divIcon = new L.divIcon({
                        className: "customer-div-icon",
                        html: getHtmlDivIcon(index, color, (((index == 0) || ((index == total - 1) && journey.returnOrigin)) ? true : false), false, indexs.includes(index)),
                        iconSize: [30, 30],
                        iconAnchor: [15, 30],
                        popupAnchor: [0, -30]
                    });

                    // Cria o marcador
                    let marker = new L.marker(waypoint.latLng, {
                        draggable: false,
                        icon: divIcon
                    }).on("mouseover", function(e) {
                        // Abre o popup quando o mouse passa por cima
                        e.target.openPopup();
                    }).on("mouseout", function(e) {
                        // Fecha o popup quando mouse sai de cima
                        e.target.closePopup();
                    }).bindPopup(
                        // Define o conteúdo do popup
                        getHtmltPopup(journey.points[(((index == 0) || ((index == total - 1) && journey.returnOrigin)) ? 0 : index)], (((index == 0) || ((index == total - 1) && journey.returnOrigin)) ? true : false), false, indexs.includes(index))
                    );
                    
                    // Adiciona o marcado no ponto
                    journey.points[index].objectMap = marker;

                    // Retorna o marcador
                    return marker;
                },
            });
            
            // Define o control da rota
            let control = new L.Routing.control({
                waypoints: waypoints,
                router: this.router,
                plan: plan,
                fitSelectedRoutes: 'smart',
                routeLine: function(route) {
                    // Define a linha da rota
                    let line = new L.Routing.line(route, {
                        addWaypoints: false,
                        styles: [
                            {color: "black", opacity: 0.15, weight: 9},
                            {color: "white", opacity: 0.8, weight: 6},
                            {color: color, opacity: 1, weight: 2}
                        ]
                    });

                    // Retorna a linha
                    return line;
                },
                units: "metric",
                showAlternatives: false,
                useZoomParameter: false,
                show: false,
                waypointMode: 'snap',
            }).on("routingstart", function(e) {
                console.log(e);
            }).on("routesfound", function(e) {
                console.log(e);
                // Define as informações da rota encontrada
                journey.totalDistance =  e.routes[0].summary.totalDistance;
                journey.totalTime = e.routes[0].summary.totalTime;
                journey.instructions = e.routes[0].instructions;
                journey.coordinates = e.routes[0].coordinates;
                processJourneysTimeAndHours(journey);
                processDistanceAndTime(e.routes[0].summary.totalDistance, e.routes[0].summary.totalTime);
            }).on("routingerror", function(e) {
                console.log(e);
                // Exibe mensagem de erro ao não encontrar rota
                notification.error("Veículo " + journey.vehicleLicensePlate + ": um erro ocorreu ao traçar a linha e não foi possível exibir no mapa a rota gerada.");
            }).addTo(this.map);
            
            // Atualiza nas informações gerais
            this.totalWeight += journey.totalWeight;
            this.totalDelivery += journey.totalDelivery;

            // Adiciona o grupo de linha e marcadores na rota
            journey.objectMap = control;
            
            // Retorna o control gerado
            return control;
        },

        /**
         * Processa os pontos da rota
         * @param {array} points lista de pontos da rota
         * @return {array} lista de pontos
         **/
        processWaypoints: function(points) {
            // Inicia lista de pontos
            let waypoints = [];
            let indexs = [];
            
            // Transforma as latitudes e longitudes
            points.map((point, index) => {
                let latLng = point.coordinates.split(",");
                waypoints.push(L.latLng(latLng[0], latLng[1]));
                // Armazena os indexs dos pontos de parada
                if ((point.movimentTypeCode != null) && (point.movimentTypeCode != "")) {
                    if (point.movimentTypeCode == this.my_settings.default_moviment_type_code) indexs.push(index);
                }
            });
            
            // Retorna a lista de pontos
            return [waypoints, indexs];
        },
        
        /**
         * Processa o tempo e as horas da rota
         * @param {Object} journey objeto com as informações da rota
         **/
        processJourneysTimeAndHours: function(journey) {
            //----------------------------
            // Define o total de tempo da janela de hora de execução da rota
            let totalTimeHour = this.getTimeInSeconds(journey.points[1].startTime, journey.points[1].endTime);

            // Salva o tempo total de atendimento
            journey.totalTimeHour = totalTimeHour;
            //----------------------------


            //----------------------------
            // Define a velocidade média em m/s
            let averageSpeed = journey.averageSpeed / 3.6;
            
            // Inicia as informações necessárias
            let between = [];
            let distance = 0;
            let time = 0;
            let totalTime = 0;
            let totalTimeRoute = 0;
            
            // Percorre o array de informações do itinerário
            journey.instructions.map(step => {
                // Verifica se é um passo de chegada a um ponto, ou chegada ao destino
                if((step.type == "WaypointReached") || (step.type == "DestinationReached")) {
                    // Define a distância e tempo entre um ponto A e B
                    between.push({
                        distance,
                        time
                    });
                    
                    // Reinicia as informações
                    distance = 0;
                    time = 0;
                } else {
                    // Soma a distância e o tempo desse passo
                    distance += step.distance;
                    time += step.distance / averageSpeed;
                }
            });
            //----------------------------
            

            //----------------------------
            // Define o total de tempo da janela de almoço
            let hasLunchTime = false;
            let startLunchTime = "";
            let hourLunchTime = new Date();

            if(journey.startLunchTime != "") {
                startLunchTime = journey.startLunchTime;
                startLunchTime = startLunchTime.split(":");
                hourLunchTime.setHours(startLunchTime[0], startLunchTime[1], "00");
            }
            //----------------------------
            

            //----------------------------
            // Percorre os pontos
            journey.points.map((point, index) => {
                // Inicia uma nova data auxiliar para manipular hora
                let hour = new Date();
                // Inicia uma nova data auxiliar para manipular hora de chegada no próximo ponto
                let hourNext = new Date();

                // Verifica se é o primeiro ponto
                if(index == 0) {
                    // Define o horário de início
                    let startTimeRoute = journey.points[1].startTime;
                    startTimeRoute = startTimeRoute.split(":");
                    
                    // Define a data com o horário de saída do centro de distribuição
                    hour.setHours(startTimeRoute[0], startTimeRoute[1], "00");
                    
                    // Salva o horário de saída no centro de distribuição
                    point.startTimeRoute =
                        (hour.getHours() < 10 ? "0" + hour.getHours() : hour.getHours()) + ":" +
                        (hour.getMinutes() < 10 ? "0" + hour.getMinutes() : hour.getMinutes()) + ":" +
                        (hour.getSeconds() < 10 ? "0" + hour.getSeconds() : hour.getSeconds());
                        
                    // Atualiza o horário com o tempo até o próximo ponto
                    hourNext = hour;
                    hourNext.setSeconds(hourNext.getSeconds() + between[index].time);
                    
                    // Salva o horário de chegada no próximo ponto
                    point.endTimeRoute =
                        (hourNext.getHours() < 10 ? "0" + hourNext.getHours() : hourNext.getHours()) + ":" +
                        (hourNext.getMinutes() < 10 ? "0" + hourNext.getMinutes() : hourNext.getMinutes()) + ":" +
                        (hourNext.getSeconds() < 10 ? "0" + hourNext.getSeconds() : hourNext.getSeconds());
                    
                    // Soma o tempo de entrega ao tempo total (sem retorno ao CD)
                    totalTime += between[index].time;
                    // Soma o tempo de entrega ao tempo total da rota (com retorno ao CD)
                    totalTimeRoute += between[index].time;
                    
                    // Salva as informações de tempo e distância entre pontos
                    point.distanceBetween = between[index].distance;
                    point.timeBetween = between[index].time;
                    point.totalTime = totalTime;
                    point.totalTimeRoute = totalTimeRoute;
                } else if((index > 0 ) && (index < between.length)) {
                    // Define o horário de início (o mesmo do fim do anterior)
                    let startTimeRoute = journey.points[index - 1].endTimeRoute;
                    startTimeRoute = startTimeRoute.split(":");
                    
                    // Define a data com o horário de início
                    hour.setHours(startTimeRoute[0], startTimeRoute[1], startTimeRoute[2]);
                    
                    // Salva o horário de chegada neste ponto
                    point.startTimeRoute =
                        (hour.getHours() < 10 ? "0" + hour.getHours() : hour.getHours()) + ":" +
                        (hour.getMinutes() < 10 ? "0" + hour.getMinutes() : hour.getMinutes()) + ":" +
                        (hour.getSeconds() < 10 ? "0" + hour.getSeconds() : hour.getSeconds());
                    
                    // Verifica se há tempo de entrega nesse ponto
                    if(point.averageWaitingTime > 0) {
                        // Adiciona o tempo de entrega neste ponto
                        hour.setSeconds(hour.getSeconds() + point.averageWaitingTime);
                        
                        // Soma o tempo de entrega ao tempo total (sem retorno ao CD)
                        totalTime += point.averageWaitingTime;
                        // Soma o tempo de entrega ao tempo total da rota (com retorno ao CD)
                        totalTimeRoute += point.averageWaitingTime;
                    }
                    
                    // Verifica se tem horário de almoço e se ainda não houve a pausa
                    if(journey.lunchTime && ((journey.lunchTime != 0) && !hasLunchTime)) {
                        // Copia a hora atual
                        let hourNextAux = new Date();
                        hourNextAux.setHours(startTimeRoute[0], startTimeRoute[1], "00");
                        
                        // Adiciona a hora atual ao tempo que seria para chegar ao próximo ponto
                        hourNextAux.setSeconds(hourNextAux.getSeconds() + between[index].time);
                        
                        // Verifica se para chegar ao próximo ponto excede o horário de almoço
                        if(hourNextAux.getHours() >= hourLunchTime.getHours()) {
                            // Define que houve o almoço
                            hasLunchTime = true;
                            
                            // Salva que teve almoço
                            point.hasLunchTime = true;

                            // Salva o horário de ínício do almoço
                            point.startLunchTime =
                                (hour.getHours() < 10 ? "0" + hour.getHours() : hour.getHours()) + ":" +
                                (hour.getMinutes() < 10 ? "0" + hour.getMinutes() : hour.getMinutes()) + ":" +
                                (hour.getSeconds() < 10 ? "0" + hour.getSeconds() : hour.getSeconds());
                            
                            // Salva o horário de início do almoço na rota
                            journey.startLunchTimeRoute = point.startLunchTime;

                            // Adiciona o tempo de almoço
                            hour.setSeconds(hour.getSeconds() + journey.lunchTime);

                            // Salva o horário de ínício do almoço
                            point.endLunchTime =
                                (hour.getHours() < 10 ? "0" + hour.getHours() : hour.getHours()) + ":" +
                                (hour.getMinutes() < 10 ? "0" + hour.getMinutes() : hour.getMinutes()) + ":" +
                                (hour.getSeconds() < 10 ? "0" + hour.getSeconds() : hour.getSeconds());
                            
                            // Salva o horário de início do almoço na rota
                            journey.endLunchTimeRoute = point.endLunchTime;

                            // Soma o tempo de espera no ponto ao tempo total (sem retorno ao CD)
                            totalTime += journey.lunchTime;
                            // Soma o tempo de espera no ponto ao tempo total da rota (com retorno ao CD)
                            totalTimeRoute += journey.lunchTime;
                        }
                    }

                    // Atualiza do tempo decorrido com o tempo até o próximo ponto, e o tempo de espera no ponto (se tiver)
                    hourNext = hour;
                    hourNext.setSeconds(hourNext.getSeconds() + between[index].time);
                    
                    // Salva o horário de chegada no próximo ponto
                    point.endTimeRoute =
                        (hourNext.getHours() < 10 ? "0" + hourNext.getHours() : hourNext.getHours()) + ":" +
                        (hourNext.getMinutes() < 10 ? "0" + hourNext.getMinutes() : hourNext.getMinutes()) + ":" +
                        (hourNext.getSeconds() < 10 ? "0" + hourNext.getSeconds() : hourNext.getSeconds());
                    
                    // Verifica o próximo ponto não é centro de distribuição
                    if(!journey.points[index + 1].isDC) {
                        // Soma o tempo de chegar ao próximo ponto (sem retorno ao CD)
                        totalTime += between[index].time;
                    }

                    // Soma o tempo de chegar ao próximo ponto (com retorno ao CD)
                    totalTimeRoute += between[index].time;

                    // Salva as informações de tempo e distância entre pontos
                    point.distanceBetween = between[index].distance;
                    point.timeBetween = between[index].time;
                    point.totalTime = totalTime;
                    point.totalTimeRoute = totalTimeRoute;
                } else {
                    // Define o horário de início
                    let startTimeRoute = journey.points[index - 1].endTimeRoute;
                    startTimeRoute = startTimeRoute.split(":");
                    
                     // Define a data com o horário de início
                    hour.setHours(startTimeRoute[0], startTimeRoute[1], startTimeRoute[2]);
                    
                    // Salva o horário de chegada no ponto
                    point.startTimeRoute =
                        (hour.getHours() < 10 ? "0" + hour.getHours() : hour.getHours()) + ":" +
                        (hour.getMinutes() < 10 ? "0" + hour.getMinutes() : hour.getMinutes()) + ":" +
                        (hour.getSeconds() < 10 ? "0" + hour.getSeconds() : hour.getSeconds());
                    
                    // Verifica se há tempo de entrega nesse ponto
                    if(point.averageWaitingTime > 0) {
                        // Adiciona o tempo de entrega neste ponto
                        hour.setSeconds(hour.getSeconds() + point.averageWaitingTime);
                        
                        // Soma o tempo de entrega ao total de tempo (com retorno ao CD)
                        totalTime += point.averageWaitingTime;
                        // Soma o tempo de entrega ao total de tempo (sem retorno ao CD)
                        totalTimeRoute += point.averageWaitingTime;
                    }

                    // Atualiza do tempo decorrido
                    hourNext = hour;
                    
                    // Salva o horário de chegada no próximo ponto
                    point.endTimeRoute =
                        (hourNext.getHours() < 10 ? "0" + hourNext.getHours() : hourNext.getHours()) + ":" +
                        (hourNext.getMinutes() < 10 ? "0" + hourNext.getMinutes() : hourNext.getMinutes()) + ":" +
                        (hourNext.getSeconds() < 10 ? "0" + hourNext.getSeconds() : hourNext.getSeconds());
                    
                    // Salva as informações de tempo e distância entre pontos
                    point.timeBetween = 0;
                    point.distanceBetween = 0;
                    point.totalTime = totalTime;
                    point.totalTimeRoute = totalTimeRoute;
                }
            });

            // Salva o tempo total do percurso com os adicionais de tempo
            journey.totalTime = totalTime;
            journey.totalTimeRoute = totalTimeRoute;
            //----------------------------
        },

        /**
         * Processa o valor geral da distância e tempo
         * @param {number} distance distância de uma rota
         * @param {number} time tempo de uma rota
         **/
        processDistanceAndTime: function(distance, time) {
            // Verifica se pode atualizar
            if(this.allowUpdate) {
                // Adiciona soma a distância do roteiro
                this.totalDistance += distance;
                // Adiciona soma a distância do roteiro
                this.totalTime += time;
                // Adiciona ao contador
                this.countRoute++;
            }
            
            // Verifica se já foi processada todas as rotas
            if(this.totalRoute == this.countRoute) {
                // Impede a atualização das informações (para casos que reescrina da rota no mapa sem processamento das entrega pelo roteirizador)
                this.allowUpdate = false;
            }
        },
        
        /**
         * Verifica se a rota já foi finalizada
         **/
        verifyFinished: async function() {
            // Preenche as informações
            this.finished = this.data.result.finished;
            
            // Verifica se há roteiro finalizado
            if(this.finished) {
                // Verifica se este é o roteiro finalizado
                if(this.finished) {
                    // Apresenta a confirmação
                    await this.$alert.alert("Este roteiro foi finalizado e atribuído ao dia " + this.getDate(this.data.base.date) + ".", "AVISO");
                }
            }
        },

        /**
         * Retorna uma cor padrão para os dropped nodes e uma aleatória para os demais pontos
         * @param {boolean} isDroppedNode se o ponto é da lista de dropped nodes
         * @return {string} cor gerada
         **/ 
         getColor: function(isDroppedNode) {
            // Verifica se é dropped node
            if(isDroppedNode) {
                // Retorna o valor padrão
                return "#888";
            } else {
                // Cria a nova cor aleatória
                let color = "#";
                let position = null;
                let newPosition = this.currentColorPosition;

                do {
                    // Inicia os auxiliares
                    color = "#";
                    let aux1 = "ff";
                    let aux2 = "00";
                    let aux3 = "";
                    let letters = 'abcde123456789'.split('');
                    
                    // Gera os caracteres que completarão a cor
                    for(let i = 0; i < 2; i++) {
                        aux3 += letters[Math.floor(Math.random() * letters.length)];
                    }
                    
                    // Define uma posição
                    position = Math.floor(Math.random() * 14);
                    
                    // Verifica a posição
                    if(position < 3) {
                        newPosition = 1;
                        color += aux1 + aux2 + aux3;
                    } else if(position >= 3 && position < 6) {
                        newPosition = 2;
                        color += aux1 + aux3 + aux2;
                    } else if(position >= 6 && position < 9) {
                        newPosition = 3;
                        color += aux3 + aux1 + aux2;
                    } else if(position >= 9 && position < 12) {
                        newPosition = 4;
                        color += aux2 + aux3 + aux1;
                    } else if(position >= 12) {
                        newPosition = 5;
                        color += aux3 + aux2 + aux1;
                    }
                } while(this.currentColorList.includes(color) || this.currentColorPosition == newPosition);
                
                // Adiciona a cor na lista de cores usadas
                this.currentColorList.push(color);
                this.currentColorPosition = newPosition;
                
                // Retorna a cor
                return color;
            }
        },
        
        /**
         * Envia um horário e retorna o tempo em segundos
         * @param {string} startTime horário de início
         * @param {string} endTime horário de término
         * @return {number} retorna o tempo em segundos
         **/
        getTimeInSeconds: function(startTime, endTime) {
            // Calcula o tempo de início da rota
            startTime = startTime.split(":");
            let startHoursInSecond = parseInt(startTime[0]) * 3600;
            let startMinutsInSecond = 0;
            if(parseInt(startTime[1]) > 0) {
                startMinutsInSecond = parseInt(startTime[1]) * 60;
            }
            let startTimeTotal = startHoursInSecond + startMinutsInSecond;
            
            // Calcula o tempo de máximo de término da rota
            endTime = endTime.split(":");
            let endHoursInSecond = parseInt(endTime[0]) * 3600;
            let endMinutsInSecond = 0;
            if(parseInt(endTime[1]) > 0) {
                endMinutsInSecond = parseInt(endTime[1]) * 60;
            }
            let endTimeTotal = endHoursInSecond + endMinutsInSecond;
            
            // Define o total da rota
            return endTimeTotal - startTimeTotal;
        },
        
        /**
         * Retorna o html do marcador
         * @param {number} index índice do ponto
         * @param {string} color cor da rota
         * @param {boolean} isDCNode se o ponto é Centro de Distribuição
         * @param {boolean} isDroppedNode se o pontos é da lista de dropped nodes
         * @param {boolean} isStoppingNode se o ponto é um ponto de parada
         * @return {string} html da div do marcador
         **/ 
        getHtmlDivIcon: function(index, color, isDCNode, isDroppedNode, isStoppingNode = false) {
            let html = "";

            // Verifica se é um nó inviável
            if(isDroppedNode) {
                // Define o html do marcador
                html = 
                    "<style>" +
                        "#droppednode-" + index + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: 50% 50% 50% 0; background-color: " + color + "; transform: rotate(-45deg); z-index: 2;}" +
                        "#droppednode-" + index + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                        "#droppednode-label-" + index + " {position: absolute; width: 22px; left: 0; right: 0; margin: 9px auto; font-size: 13px; color: " + color + "; text-align: center; z-index: 3;}" +
                    "</style>" +
                    "<div id='droppednode-" + index + "'></div><div id='droppednode-label-" + index + "' class='fa fa-exclamation-circle'></div>";
            } else {
                let borderRadius = "";
                let margin = "";
                let random = Math.floor(Math.random() * 123456789);
                
                // Verifica se é DC
                if(isDCNode) {
                    color = "#303030";
                    borderRadius = "50% 50% 50% 0";
                    margin = "8px auto";
                } else {
                    if (isStoppingNode) {
                        borderRadius = "10% 10% 10% 0";
                    } else {
                        borderRadius = "50% 50% 50% 0";
                    }
                    margin = "6px auto";
                }

                // Define o html do marcador
                html =
                    "<style>" +
                        "#journeynode-" + index + "-" + random + " {width: 30px; height: 30px; position: absolute; border: 2px solid white; border-radius: " + borderRadius + "; background-color: " + color + "; transform: rotate(-45deg); z-index: 2;}" +
                        "#journeynode-" + index + "-" + random + "::after {content: ''; position: absolute; width: 20px; height: 20px; margin: 3px 0 0 3px; background: #fff; border-radius: 50%; z-index: 3;}" +
                        "#journeynode-label-" + index + "-" + random + " {position: absolute; width: 22px; left: 0; right: 0; margin: " + margin + "; font-size: 12px; color: " + color + "; text-align: center; z-index: 3;}" +
                    "</style>" +
                    "<div id='journeynode-" + index + "-" + random + "'></div><div id='journeynode-label-" + index + "-" + random + "' " + ((isDCNode) ? "class='fa fa-home'" : "") + ">" + ((isDCNode) ? "" : index) + "</div>";
            }
            
            // Retorna o html do marcador
            return html;
        },
        
        /**
         * Retorna um html para o popup
         * @param {object} item journey.journeyPoint com o ponto
         * @param {boolean} isDCNode se é Centro de Distribuição
         * @param {boolean} isDroppedNode se é da lista de dropped nodes
         * @param {boolean} isStoppingNode se o ponto é um ponto de parada
         * @return {string} html da div de popup do marcador
         **/
        getHtmltPopup: function(item, isDCNode, isDroppedNode, isStoppingNode = false) {
            let html = "";
            
            // Verifica se é Centro de Distribuição
            if(isDCNode) {
                html =
                    '<div class="popup">' +
                        '<h3><b>Centro de Distribuição</b></h3>' +
                        '<p class="marker"><b>' +  item.dcName + '</b></p>' +
                        '<hr/>' +
                        '<p class="marker capitalized"><i class="fa fa-map-marker-alt"></i> Endereço: ' +  item.addressStreet.toLowerCase() + ', ' + (item.addressNumber ? item.addressNumber.toLowerCase() : "") + ' - ' + (item.addressNeighborhood ? item.addressNeighborhood.toLowerCase() : "") + '</p>' +
                        '<p class="marker capitalized"><i class="fa fa-globe-americas"></i> Local: ' +  item.addressCity.toLowerCase() + ' - ' + item.addressUf + ', ' + item.addressPostalCode + '</p>' +
                    '</div>';
            } else {
                if(isDroppedNode) {
                    html =
                        '<div class="popup">' +
                            '<h3><b style="padding: 5px; background-color: #ccc; border-radius: 4px"><i class="fas fa-box"></i> Entrega desvinculada</b></h3>' +
                            '<h3><b>Entrega: ' +  item.documentNumber + '</b></h3>' +
                            '<p class="marker"><b>' +  item.customerName + '</b></p>' +
                            '<hr/>' +
                            '<p class="marker capitalized"><i class="fa fa-map-marker-alt"></i> Endereço: ' +  item.addressStreet.toLowerCase() + ", " + (item.addressNumber ? item.addressNumber.toLowerCase() : "") + " - " + (item.addressNeighborhood ? item.addressNeighborhood.toLowerCase() : "") + '</p>' +
                            '<p class="marker capitalized"><i class="fa fa-globe-americas"></i> Local: ' +  item.addressCity.toLowerCase() + ' - ' + item.addressUf + ', ' + item.addressPostalCode + '</p>' +
                        '</div>';
                } else {
                    let stopping = "";
                    let time = "";
                    let averageWaitingTime = "";
                    let quantity = "";

                    if (isStoppingNode) stopping = '<h3><b style="padding: 5px; background-color: #ccc; border-radius: 4px"><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></h3>';

                    if(item.startTime && item.endTime) time = '<p class="marker"><i class="fa fa-clock"></i> Janela de atendimento: ' +  item.startTime + ' - ' + item.endTime + '</p>';

                    if(item.averageWaitingTime) averageWaitingTime = '<p class="marker"><i class="fa fa-people-carry"></i> Tempo médio de descarregamento: ' +  Math.round(item.averageWaitingTime / 60) + ' min</p>';
                    
                    if(item.quantity) quantity = '<p class="marker"><i class="fa fa-boxes"></i> Quantidade: ' +  item.quantity + '</p>';

                    html =
                        '<div class="popup">' +
                            stopping +
                            '<h3><b>Entrega: ' +  item.documentNumber + '</b></h3>' +
                            '<p class="marker"><b>' + item.customerName + '</b></p>' +
                            '<hr/>' +
                            '<p class="marker capitalized"><i class="fa fa-map-marker-alt"></i> Endereço: ' +  item.addressStreet.toLowerCase() + ", " + (item.addressNumber ? item.addressNumber.toLowerCase() : "") + " - " + (item.addressNeighborhood ? item.addressNeighborhood.toLowerCase() : "") + '</p>' +
                            '<p class="marker capitalized"><i class="fa fa-globe-americas"></i> Local: ' +  item.addressCity.toLowerCase() + ' - ' + item.addressUf + ', ' + item.addressPostalCode + '</p>' +
                            time +
                            averageWaitingTime +
                            quantity +
                            '<p class="marker"><i class="fa fa-weight-hanging"></i> Peso total: ' +  this.getWeight(item.weight) + '</p>' +
                        '</div>';
                }
            }

            // Retorna o html do popup
            return html;
        },
        
        /**
         * Retorna a data formatada
         * @param {string} date data completa não formatada
         * @return {string} sata não formatada
         **/
        getDate: function(date) {
            let dateAux = new Date(date);
            let dateFormated = "";

            dateFormated = ((dateAux.getDate() < 10) ? "0" + dateAux.getDate() : dateAux.getDate()) + "/";
            dateFormated += (((dateAux.getMonth() + 1) < 10) ? "0" + (dateAux.getMonth() + 1) : (dateAux.getMonth() + 1)) + "/";
            dateFormated += dateAux.getFullYear();

            return dateFormated;
        },

        /**
         * Retorna a data formatada para salvar
         * @param {string} date data completa não formatada
         * @return {string} sata não formatada
         **/
        getDateToSave: function(date) {
            let dateFormated = "";
            dateFormated += date.getFullYear() + "-";
            dateFormated += (((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "-";
            dateFormated += (date.getDate() < 10) ? "0" + date.getDate(): date.getDate();

            return dateFormated;
        },

        /**
         * Retorna a data formatada para enviar ao ERP
         * @param {string} date data completa não formatada
         * @return {string} sata não formatada
         **/
        getDateToSend: function(date) {
            let dateFormated = "";
            dateFormated += date.getFullYear() + "-";
            dateFormated += (((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "-";
            dateFormated += (date.getDate() < 10) ? "0" + date.getDate(): date.getDate();
            dateFormated += "T" + ((date.getHours() < 10) ? "0" + date.getHours() : date.getHours());
            dateFormated += ":" + ((date.getMinutes() < 10) ? "0" + date.getMinutes() : date.getMinutes());
            dateFormated += ":" + ((date.getSeconds() < 10) ? "0" + date.getSeconds() : date.getSeconds()) + ".000000Z";

            return dateFormated;
        },

        /**
         * Retorna o peso
         * @param {number} weight peso em quilos
         * @return {string} peso em quilos ou toneladas
         */
		getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight.toFixed(2) + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },

        /**
         * Marca/Desmarca todos os registros
         * @param {boolean} isDroppedNode se os registros são da lista de dropped nodes
         **/ 
        selectAll: function(isDroppedNode) {
            let list = null;
            let selectedList = null;
            
            // Verifica se é da lista de dropped nodes
            if(isDroppedNode) {
                list = this.droppedNodesList;
                selectedList = this.selectedDroppedNodesList;
            } else {
                list = this.journeyWithRouteList;
                selectedList = this.selectedJourneyWithRouteList;
            }
            
            // Verifica se todos estão selecionados
            if(list.length != selectedList.length) {
                // Pecorre a lista
                list.map((e, index) => {
                    // Verifica se está na lista de selecionados
                    if(!selectedList.includes(e)) {
                        selectedList.push(e);
                    }

                    // Verifica se é da lista de dropped nodes
                    if(!isDroppedNode) {
                        // Adiciona o control ao mapa
                        this.map.addControl(this.controlJourneyWithRouteList[index]);
                        
                        // Remove as divs do summary default
                        this.hideControlDivs();
                    }
                });
                
                // Verifica se é da lista de dropped nodes
                if(isDroppedNode) {
                    // Adiciona a lista de marcadores em um grupo e a adiciona ao mapa
                    this.layerGroupDroppedNode = L.layerGroup(this.markerDroppedNodeList).addTo(this.map);
                }
            } else {
                // Pecorre a lista
                list.map((e, index) => {
                    // Identifica a posição na lista
                    let indexOF = selectedList.indexOf(e);
                    if(indexOF !== false) {
                        // Remove a posição da lista
                        selectedList.splice(indexOF, 1);
                    }

                    // Verifica se é dropped nodes
                    if(!isDroppedNode) {
                        // Remove o control da rota do mapa
                        this.map.removeControl(this.controlJourneyWithRouteList[index]);
                    }
                });

                // Verifica se é dropped nodes
                if(isDroppedNode) {
                    // Limpa os marcadores do mapa
                    this.layerGroupDroppedNode.clearLayers();
                }

                // Remove o journey
                this.removeCurrentJourney();
            }
        },
        
        /**
         * Marca/desmarca ao selecionar um registro individualmente
         * @param {object} item registro da rota
         * @param {number} index índice da posição da rota
         * @param {boolean} isDroppedNode se o registro é da lista de dropped nodes
         **/ 
        onSelect: function(item, index, isDroppedNode) {
            // Inicia as informações
            let selectedList = null;
            let layerGroup = null;
            
            // Verifica se é dropped
            if(isDroppedNode) {
                // Define as informações
                layerGroup = this.layerGroupDroppedNode;
                selectedList = this.selectedDroppedNodesList;
            } else {
                // Define as informações
                layerGroup = this.controlJourneyWithRouteList[index];
                selectedList = this.selectedJourneyWithRouteList;
            }
            
            // Verifica se está na lista de selecionados
            if(selectedList.includes(item)) {
                // Remove da lista
                let indexOF = selectedList.indexOf(item);
                if(indexOF !== false) {
                    selectedList.splice(indexOF, 1);
                }
                
                // Verifica se pe um dropped node
                if(isDroppedNode) {
                    if(layerGroup.hasLayer(item.objectMap)) {
                        layerGroup.removeLayer(item.objectMap);
                    }
                } else {
                    this.map.removeControl(layerGroup);
                    
                    // Verifica se está tualmente em exibição
                    if(this.currentJourney == item) {
                        this.removeCurrentJourney();
                    }
                }
            } else {
                // Adiciona a lista
                selectedList.push(item);
                
                // Verifica se é um dropped node
                if(isDroppedNode) {
                    // Verifica se existe a layer
                    if(!layerGroup.hasLayer(item.objectMap)) {
                        // Adiciona a layer ao grupo
                        layerGroup.addLayer(item.objectMap);
                    }
                } else {
                    // Adiciona o control ao mapa
                    this.map.addControl(layerGroup);
                    // Remove as div de intinerário default
                    this.hideControlDivs();
                }
            }
		},

        /**
         * Retorna o marcador a z index anterior
         * @param {object} item ponto da rota
         *  */ 
        onMouseOut: function(item) {
            // Coloca o marcado mais visível
            item.setZIndexOffset(0).closePopup();
        },
        
        /**
		 * Adiciona o marcador ao mapa
		 * @param {number} index ínidice da coordenada
		 **/
        onMouseOverInstruction: function(index) {
			// Obtem as coordenadas
			let pointCoordinates = this.currentJourney.coordinates[index];
			let pointLatLng = L.latLng(pointCoordinates.lat, pointCoordinates.lng);
			
			// Cria o marcador
			this.markerInstruction = new L.marker(pointLatLng, {
				draggable: false,
				icon: L.divIcon({
					className: "customer-div-icon",
					html: 
						"<style>" +
							"#node-instruction-" + index + " {width: 10px; height: 10px; position: absolute; background-color: " + this.currentJourney.color + "; border: 2px solid white; border-radius: 50%;}" +
						"</style>" +
						"<div id='node-instruction-" + index + "'></div>"
					,
					iconSize: [10, 10],
				}),
			});

			// Adiciona no mapa
			this.markerInstruction.addTo(this.map);

			// Atualiza o zom e center do map
            this.map.setView(pointLatLng, 16, {
                animation: true
            });
        },

        /**
         * Remove o marcado do mapa
         * @param {number} index ponto da rota
         **/ 
        onMouseOutInstruction: function() {
			// Remove o marcador do mapa
            this.map.removeLayer(this.markerInstruction);
        },
        
        /**
         * Define o rota selecionada na exibição
         * @param {object} item ponto da rota
         * @param {number} index índice do ponto na lista
         **/ 
        setCurrentJourney: function(item, index) {
            let selectedList = this.selectedJourneyWithRouteList;

            // Verifica se é a rota em exibição atualmente
            if(this.currentJourney != item) {
                // Verifica se está na lista de selecionados
                if(!selectedList.includes(item)) {
                    // Adiciona a lista
                    selectedList.push(item);
                }

                // Define as informações da rota atual
                this.currentJourney = item;
                this.currentJourneyIndex = index;

                // Define a tab de exibição
                this.currentSummary = 'route';
                
                // Remove do mapa e adiciona logo em seguida pra colocar em primeiro plano
                this.map.removeControl(this.controlJourneyWithRouteList[index]);
                this.map.addControl(this.controlJourneyWithRouteList[index]);

                // Remove as divs de intinerário default
                this.hideControlDivs();
            }
        },
        
        /**
         * Remove a rota atual da seleção
         **/ 
        removeCurrentJourney: function() {
            // Reinicia as informações
            this.currentJourney = null;
            this.currentJourneyIndex = null;
            this.currentSummary = 'route';
            
            // Reinicia a posição do mapa
            this.map.setView(L.latLng(this.center[0], this.center[1]), this.zoom, {
                animation: true
            });
        },

        /**
         * Seleciona a rota a ser editada
         * @param {object} item ponto da rota
         * @param {number} index índice do ponto na lista
         * @param {boolean} hasRoute informa se é da lista de veículos com rotas
         **/ 
        setEditCurrentJourney: function(item, index, hasRoute) {
            // Define as informações da rota atual
            this.editCurrentJourney = item;
            this.editCurrentJourneyIndex = index;
            this.editCurrentJourneyHasRoute = hasRoute;
            this.showModalEditJourney = true;
        },
        
        /**
         * Remove as informações da rota atualmente em edição
         **/
        removeEditCurrentJourney: function() {
            // Remove as informações de edição
            this.showModalEditJourney = false;
            this.editCurrentJourney = null;
            this.editCurrentJourneyIndex = null;
            this.editCurrentJourneyHasRoute = false;
        },

        /**
         * Define o rota selecionada na exibição
         * @param {object} item ponto da rota
         * @param {number} index índice do ponto na lista
         **/ 
        setSequenceCurrentJourney: function(item, index) {
            // Seleciona se não estiver na lista
            this.setCurrentJourney(item, index);

            // Define as informações da rota atual
            this.sequenceCurrentJourney = item;
            this.sequenceCurrentJourneyIndex = index;
            this.showModalSequenceJourney = true;
        },
        
        /**
         * Remove a rota atual da seleção
         **/ 
        removeSequenceCurrentJourney: function() {
            // Reinicia as informações
            this.showModalSequenceJourney = false;
            this.sequenceCurrentJourney = null;
            this.sequenceCurrentJourneyIndex = null;
        },

        /**
         * Seleciona a rota a ser editada
         * @param {object} item ponto da rota
         * @param {number} index índice do ponto na lista
         **/ 
         setEditCurrentJourneyColor: function(index) {
            // Define as informações da rota atual
            this.editCurrentJourneyIndex = index;
            this.updateEditCurrentJourneyColor();
        },
        
        /**
         * Atualiza a cor da rota atual
         */
        updateEditCurrentJourneyColor: function() {
            // Verifica se exite 
            if (typeof this.journeyWithRouteList[this.editCurrentJourneyIndex] !== "undefined") {
                // Atualiza Dom da tabela
                this.$refs.route.update();
                
                // Processa o grupo control da rota
                let control = this.processJourneyIndividual(this.journeyWithRouteList[this.editCurrentJourneyIndex]);

                // Remove o control antigo do mapa
                this.map.removeControl(this.controlJourneyWithRouteList[this.editCurrentJourneyIndex]);

                // Adiciona o grupo de linha e marcadores na lista
                this.controlJourneyWithRouteList[this.editCurrentJourneyIndex] = control;

                // Adiciona o control ao mapa
                this.map.addControl(control);
                
                // Limpa as informações
                this.removeEditCurrentJourneyColor();
                this.removeCurrentJourney();

                // Atualiza Dom da tabela
                this.$refs.route.update();
            }
        },
        
        /**
         * Remove as informações setadas da edição de cor
         */
        removeEditCurrentJourneyColor: function() {
            // Remove as informações setadas
            this.editCurrentJourneyIndex = null;
        },

        /**
         * Esconde as div de itinerário original no leaflet
         * @param {boolean} setTime se deve aplicar tempo para remoção das divd de itinerário original no leaflet
         **/ 
        hideControlDivs: function(setTime) {
            // Verifica se é para aplicar tempo
            if(setTime) {
                // Contador de tempo
                setTimeout(() => {
                    // Obtem a lista de divs
                    let controls = $(".leaflet-routing-container");
                    // Verifica se foi encontrado alguma div
                    if(controls.length > 0) {
                        // Oculta todas as divs
                        for(let i = 0; i < controls.length; i++) {
                            controls[i].style.display = "none";
                        }
                    }
                }, 600);
            } else {
                // Obtem a lista de divs
                let controls = $(".leaflet-routing-container");
                // Verifica se foi encontrado alguma div
                if(controls.length > 0) {
                    // Oculta todas as divs
                    for(let i = 0; i < controls.length; i++) {
                        controls[i].style.display = "none";
                    }
                }
            }
        },
        
        /**
         * Constroi os veículos a serem enviados para a api de roterização
         * @param {object} vehicle objeto com informações do veículo
         * @return {object} objeto do veículo contruído
         **/ 
        buildVehicle(vehicle) {
            let JourneyVehicleDTO = new Object();
            
            JourneyVehicleDTO.id = vehicle.id;
            JourneyVehicleDTO.weightCapacity = vehicle.vehicleWeightCapacity;
            JourneyVehicleDTO.returnOrigin = vehicle.returnOrigin;

            return JourneyVehicleDTO;
        },

        /**
         * Constroi os pontos a serem enviados para a API de roterização.
         * @param {object} point objeto com informações do ponto
         * @param {boolean} timeContraints verdade ou false se tem restrição de tempo
         * @return {object} objeto do ponto contruído
         **/ 
        buildPoint(point, timeConstraints) {
            let JourneyPointDTO = new Object();
            
            let startTime = point.startTime.split(":");
            let endTime = point.endTime.split(":");
            
            JourneyPointDTO.id = point.id;
            JourneyPointDTO.documentIdentifier = point.documentIdentifier ? point.documentIdentifier : "";
            JourneyPointDTO.coordinates = point.coordinates;
            JourneyPointDTO.demands = [point.weight];
            JourneyPointDTO.startTime = timeConstraints ? startTime[0] + ":" + startTime[1] : "";
            JourneyPointDTO.endTime = timeConstraints ? endTime[0] + ":" + endTime[1] : "";
            JourneyPointDTO.averageDischargeTime = point.averageDischargeTime;
            JourneyPointDTO.dischargeWeightPerMinut = point.dischargeWeightPerMinut;
            
            // Retorna o ponto
            return JourneyPointDTO;
        },
        
        /**
         * Valida as informação que serão roteirizadas
         * @param {object} journey objeto com informações da rota
         * @param {array} points array de objeto com informações das entregas
         * @return {object} objeto com status e a informações de erro ou objeto da rota a ser processada
         **/
        buildJourney: function(journey, points) {
            // Inicia o objeto da rota
            let JourneyDTO = new Object();
            let error = false;
            
            // Separa as informações do horário de almoço
            let startLunchTime = journey.startLunchTime.split(":");
            let endLunchTime = journey.startLunchTime.split(":");
            
            // Define as informações da rota
            JourneyDTO.depot = 0;
            JourneyDTO.startLunchTime = startLunchTime[0] + ":" + startLunchTime[1];
            JourneyDTO.endLunchTime = endLunchTime[0] + ":" + endLunchTime[1];
            JourneyDTO.averageSpeed = journey.averageSpeed;
            JourneyDTO.averageDischargeTime = journey.averageDischargeTime;
            JourneyDTO.dischargeWeightPerMinut = journey.dischargeWeightPerMinut;
            JourneyDTO.correctionFact = this.data.base.correctionFact;
            JourneyDTO.weightConstraints = journey.weightConstraints;
            JourneyDTO.timeConstraints = journey.timeConstraints;
            JourneyDTO.points = [];
            JourneyDTO.vehicles = [];

            // Adiciona a lista de veículo
            JourneyDTO.vehicles.push(this.buildVehicle(journey, JourneyDTO.startLunchTime, JourneyDTO.endLunchTime));
            
            // Verifica se há pontos
            if(points.length > 0) {
                // Percorre a lista de pontos
                points.map((point, index) => {
                    // Verifica se é um centro de distribuição
                    if(index == 0) {
                        point.startTime = "00:00";
                        point.endTime = "00:00";
                    }

                    // Adiciona a lista de pontos
                    JourneyDTO.points.push(this.buildPoint(point, JourneyDTO.timeConstraints));
                });                        
            } else {
                error = "Não há encomendas relacionadas a este veículo.";
            }
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return {
                    error: true,
                    data: error
                };
            } else {
                // Retorna o objeto da rota
                return {
                    error: false,
                    data: JourneyDTO
                }
            }
        },

        /**
         * Recebe e atualiza as rotas atualmente em edição com as informações passadas
         * @param {array} editResult array com os objtos resultantes da edição, [0] journey, [1] dropped nodes
         **/ 
         updateJourneyEdited: async function(editResult) {
            let messageResult = [];
            
            // Informa o fim do carregamento
            this.loading = true;
            
            // Percorre as informaões editadas
            for(let item of editResult[0]) {
                // Verifica se tem entregas relacionadas ao veículo
                if(item.points.length > 1) {
                    // Verifica se é para roteirizar
                    if (item.routing) {
                        // Requisita ao roteirizador e retorna o resultado
                        let messageResultAux = await this.sendAndProccessJourneyEdited(item);
                        
                        // Concatena com a lista de resultados
                        messageResult = messageResult.concat(messageResultAux);
                    } else {
                        // Permite atualizar as informações
                        this.allowUpdate = true;

                        // Ordena conforme a sequência
                        item.points.sort(function(a, b) {
                            if (!a.isDC && !b.isDC) {
                                if (a.sequence > b.sequence) return 1;
                                else if (a.sequence < b.sequence) return -1;
                                else return 0;
                            }
                        });
                        
                        // Atualiza as informações
                        this.updateNodes(item.points);
                        this.updateJourney(item, item.points);
                        
                        // Retorna mensagem de feedback
                        messageResult.push({
                            error: false,
                            message: "Veículo " + item.journey.vehicleLicensePlate + ": edição concluída."
                        });
                    }
                } else {
                    // Atualiza as informações
                    this.updateNodes(item.points);
                    this.updateJourney(item, item.points);

                    // Adiciona ao array de mensagens
                    if (item.journey.points > 1) {
                        messageResult.push({
                            error: false,
                            message: "Veículo " + item.journey.vehicleLicensePlate + ": otimização de carga e rota concluída."
                        });
                    }
                    messageResult.push({
                        error: (editResult[1].length > 0) ? true : false,
                        message: "Veículo " + item.journey.vehicleLicensePlate + ": " + editResult[1].length + " entregas desvinculadas."
                    });
                }
            }

            // Atualiza as informações
            this.updateDroppedNodes(editResult[1]);

            // Atualiza as informações gerais
            //this.updateGeneralInformation();

            // Remove o journey
            this.removeCurrentJourney();

            // Reinicia o editar e fecha o modal
            this.removeEditCurrentJourney();

            // Informa o fim do carregamento
            this.loading = false;

            // Remove as div de intinerário default
            this.hideControlDivs();
            
            // Exibe as mensagens
            messageResult.map(item => {
                if(!item.error) {
                    this.$notification.success(item.message);
                } else {
                    this.$notification.error(item.message);
                }
            });
		},
        
        /**
         * Envia ao roteirizador e reprocessa as informações editadas
         * @param {object} edit objeto com as informações da edição
         * @return array resultado do processamento de edição
         **/
        sendAndProccessJourneyEdited: async function(edit) {
            // Inicia a variável de feedback dos resultados
            let messageResult = [];
            
            // Solicita a validação
            let form = this.buildJourney(edit.journey, edit.points);
            
            // Verifica o resultado da validação
            if(form.error) {
                // Adiciona ao feedback
                messageResult.push({
                    error: true,
                    message: form.data
                });

                // Retorna o resultado
                return messageResult;
            }

            // Inicia o objeto de retorno
            let result = null;
            
            // Requisita a API
            try {
                result = await Api.routing(form.data);
            } catch(ex) {
                // Exibe no log do console o erro
                console.log("Erro ao roteirizar o veículo " + edit.journey.vehicleLicensePlate + ".");
                console.log(ex);
                
                // Conta 120 segundos para tentar roteirizar novamente
                setTimeout(async () => {
                    // Requisita novamente a API
                    try {
                        result = await Api.routing(form.data);
                    } catch(ex) {
                        // Exibe no log do console o erro
                        console.log("Erro ao roteirizar o veículo " + edit.journey.vehicleLicensePlate + ".");
                        console.log(ex);
                        
                        // Adiciona ao feedback
                        messageResult.push({
                            error: true,
                            message: "Veículo " + edit.journey.vehicleLicensePlate + ": não foi possível obter a rota."
                        });
                        
                        // Retorna o resultado
                        return messageResult;
                    }
                }, 10 * 1000);
            }

            // Verifica se foi retornado alguma informação
            if(result != null) {
                //Verifica o resultado da requisição
                if(!result.error) {
                    // Verifica se tem restrição de tempo
                    if(result.result.timeConstraints) {
                        // Verifica se teve entregas desvinculadas
                        if(result.result.droppedNodes.length > 0) {
                            // Pede a confirmação
                            let confirm = await this.$alert.confirm("A rota gerada para o veículo " + edit.journey.vehicleLicensePlate + " excedeu o limite do tempo de entrega, portanto algumas entregas foram desvinculadas. Deseja DESCONSIDERAR A RESTRIÇÃO DE TEMPO PARA ESTE VEÍCULO ?", "AVISO");
                            
                            // Verifica a confirmação
                            if(confirm) {
                                // Atualiza a restrição de tempo
                                edit.journey.timeConstraints = false;
                                
                                // Reenvia a os dados
                                return await this.sendAndProccessJourneyEdited(edit);
                            } else {
                                // Atualiza as informações
                                result.result.journeys[0].points = result.result.journeys[0].points.map(point => {
                                    return Object.assign({}, this.data.base.points[point.id], point);
                                });
                                result.result.droppedNodes = result.result.droppedNodes.map(point => {
                                    return Object.assign({}, this.data.base.points[point.id], point);
                                });

                                // Permite atualizar as informações
                                this.allowUpdate = true;

                                // Atualiza as informações
                                this.updateNodes(result.result.journeys[0].points);
                                this.updateDroppedNodes(result.result.droppedNodes);
                                this.updateJourney(edit, result.result.journeys[0].points);
                                
                                // Adiciona ao array de mensagens
                                messageResult.push({
                                    error: false,
                                    message: "Veículo " + edit.journey.vehicleLicensePlate + ": otimização de carga e rota concluída."
                                });
                                messageResult.push({
                                    error: (result.result.droppedNodes.length > 0) ? true : false,
                                    message: "Veículo " + edit.journey.vehicleLicensePlate + ": " + result.result.droppedNodes.length + " entregas desvinculadas."
                                });
                                
                                // Retorna o resultado
                                return messageResult;
                            }
                        } else {
                            // Atualiza as informações
                            result.result.journeys[0].points = result.result.journeys[0].points.map(point => {
                                return Object.assign({}, this.data.base.points[point.id], point);
                            });
                            result.result.droppedNodes = result.result.droppedNodes.map(point => {
                                return Object.assign({}, this.data.base.points[point.id], point);
                            });

                            // Permite atualizar as informações
                            this.allowUpdate = true;

                            // Atualiza as informações
                            this.updateNodes(result.result.journeys[0].points);
                            this.updateDroppedNodes(result.result.droppedNodes);
                            this.updateJourney(edit, result.result.journeys[0].points);

                            // Adiciona ao array de mensagens
                            messageResult.push({
                                error: false,
                                message: "Veículo " + edit.journey.vehicleLicensePlate + ": otimização de carga e rota concluída."
                            });
                            messageResult.push({
                                error: (result.result.droppedNodes.length > 0) ? true : false,
                                message: "Veículo " + edit.journey.vehicleLicensePlate + ": " + result.result.droppedNodes.length + " entregas desvinculadas."
                            });

                            // Retorna o resultado
                            return messageResult;
                        }
                    } else {
                        // Atualiza as informações
                        result.result.journeys[0].points = result.result.journeys[0].points.map(point => {
                            return Object.assign({}, this.data.base.points[point.id], point);
                        });
                        result.result.droppedNodes = result.result.droppedNodes.map(point => {
                            return Object.assign({}, this.data.base.points[point.id], point);
                        });

                        // Permite atualizar as informações
                        this.allowUpdate = true;
                        
                        // Atualiza as informações
                        this.updateNodes(result.result.journeys[0].points);
                        this.updateDroppedNodes(result.result.droppedNodes);
                        this.updateJourney(edit, result.result.journeys[0].points);
                        
                        // Adiciona ao array de mensagens
                        messageResult.push({
                            error: false,
                            message: "Veículo " + edit.journey.vehicleLicensePlate + ": otimização de carga e rota concluída."
                        });
                        messageResult.push({
                            error: false,
                            message: "Veículo " + edit.journey.vehicleLicensePlate + ": " + result.result.droppedNodes.length + " entregas desvinculadas."
                        });

                        // Retorna o resultado
                        return messageResult;
                    }
                } else {
                    // Adiciona ao array de mensagens
                    messageResult.push({
                        error: true,
                        message: result.data
                    });
                    
                    // Retorna o resultado
                    return messageResult;
                }
            } else {
                // Adiciona ao feedback
                messageResult.push({
                    error: true,
                    message: "Veículo " + edit.journey.vehicleLicensePlate + ": não foi possível obter a rota."
                });
                
                // Retorna o resultado
                return messageResult;
            }
        },

        /**
         * Atualiza o sequencia editada
         * @param {object} item pontos da rota
         **/ 
        updateSequence: function(item) {
            let messageResult = [];
            
            // Permite atualizar as informações
            this.allowUpdate = true;

            // Informa o início do carregamento
            this.loading = true;
            
            // Atualiza as informações
            this.updateJourney(item, item.points);
            
            // Adiciona ao array de mensagens
            messageResult.push({
                error: false,
                message: "Veículo " + item.journey.vehicleLicensePlate + ": atualização da rota concluída."
            });

            // Atualiza as informações gerais
            //this.updateGeneralInformation();

            // Remove o journey
            this.removeCurrentJourney();

            // Reinicia e fecha o modal de sequência
            this.removeSequenceCurrentJourney();

            // Remove as div de intinerário default
            this.hideControlDivs();
            
            // Informa o fim do carregamento
            this.loading = false;

            // Exibe as mensagens
            messageResult.map(item => {
                if(!item.error) {
                    this.$notification.success(item.message);
                } else {
                    this.$notification.error(item.message);
                }
            });
        },
        
        /**
         * Atualiza as informações da rota editada
         * @param {object} item objeto com as informações da edição
         * @param {array} nodes array com a lista de entregas
         **/
        updateJourney: function(item, nodes) {
            // Verifica se o veículo tem rota
            if(nodes.length > 1) {
                // Verifica se o veículo tinha rota ou não
                if(item.hasRoute) {
                    // Remove as informações da rota do total do roteiro
                    this.totalDelivery -= item.journey.returnOrigin ? item.journey.points.length - 2 : item.journey.points.length - 1;
                    this.totalWeight -= item.journey.totalWeight;
                    this.totalDistance -= item.journey.totalDistance;
                    this.totalTime -= item.journey.totalTime;

                    // Atualiza a lista de pontos
                    item.journey.points = nodes;
                    
                    // Atualiza informações
                    item.journey.totalDelivery = item.journey.returnOrigin ? item.journey.points.length - 2 : item.journey.points.length - 1;
                    item.journey.totalWeight = 0;
                    item.journey.points.map(point => {
                        item.journey.totalWeight += point.weight;
                    });
                    item.journey.totalDistance = 0;
                    item.journey.totalTime = 0;

                    // Verifica se o veículo estava na lista de veículos com rota
                    if(this.journeyWithRouteList.includes(item.journey)) {
                        // Identifica o índice na lista
                        let indexOf = this.journeyWithRouteList.indexOf(item.journey);
                        // Atuliza o objeto na lista com rotas
                        this.journeyWithRouteList[indexOf] = item.journey;
                    }
                    
                    // Atualiza as informações de rota
                    this.countRoute--;

                    // Processa o grupo control da rota
                    let control = this.processJourneyIndividual(item.journey);

                    // Remove o control antigo do mapa
                    this.map.removeControl(this.controlJourneyWithRouteList[item.index]);

                    // Adiciona o grupo de linha e marcadores na lista
                    this.controlJourneyWithRouteList[item.index] = control;

                    // Adiciona o control ao mapa
                    this.map.addControl(control);
                } else {
                    // Verifica se o veículo estava na lista de veículos sem rotas
                    if(this.journeyWithoutRouteList.includes(item.journey)) {
                        // Identifica o índice na lista
                        let indexOf = this.journeyWithoutRouteList.indexOf(item.journey);
                        // Identifica a posição na lista
                        if (indexOf !== false) {
                            // Remove da lista
                            this.journeyWithoutRouteList.splice(indexOf, 1);
                        }
                    }
                    
                    // Atualiza a lista de pontos
                    item.journey.points = nodes;
                    
                    // Atualiza informações
                    item.journey.totalDelivery = item.journey.returnOrigin ? item.journey.points.length - 2 : item.journey.points.length - 1;
                    item.journey.totalWeight = 0;
                    item.journey.points.map(point => {
                        item.journey.totalWeight += point.weight;
                    });
                    item.journey.totalDistance = 0;
                    item.journey.totalTime = 0;
                    
                    // Adiciona a lista de veículos com rotas
                    this.journeyWithRouteList.push(item.journey);

                    // Atualiza as informações de rota
                    this.totalRoute = this.journeyWithRouteList.length;

                    // Adiciona a lista de veículos selecionados
                    this.selectedJourneyWithRouteList.push(item.journey);

                    // Processa o grupo control da rota
                    let control = this.processJourneyIndividual(item.journey);

                    // Adiciona o grupo de linha e marcadores na lista
                    this.controlJourneyWithRouteList.push(control);

                    // Adiciona o control ao mapa
                    this.map.addControl(control);
                }
            } else {
                // Verifica se o veículo possui rota
                if(item.hasRoute) {
                    // Verifica se o veículo estava na lista de veículos com rota
                    if(this.journeyWithRouteList.includes(item.journey)) {
                        // Remove as informações da rota do total do roteiro
                        this.totalDelivery -= item.journey.returnOrigin ? item.journey.points.length - 2 : item.journey.points.length - 1;
                        this.totalWeight -= item.journey.totalWeight;
                        this.totalDistance -= item.journey.totalDistance;
                        this.totalTime -= item.journey.totalTime;

                        // Identifica o índice na lista
                        let indexOf = this.journeyWithRouteList.indexOf(item.journey);
                        // Identifica a posição na lista
                        if (indexOf !== false) {
                            // Remove da lista
                            this.journeyWithRouteList.splice(indexOf, 1);
                        }

                        // Atualiza as informações de rota
                        this.totalRoute = this.journeyWithRouteList.length;
                        this.countRoute--;
                        
                        // Remove o control do mapa
                        this.map.removeControl(this.controlJourneyWithRouteList[indexOf]);

                        // Remove o control da lista
                        this.controlJourneyWithRouteList.splice(indexOf, 1);
                    }
                    
                    // Verifica se o veículo estava na lista de selecionadas
                    if(this.selectedJourneyWithRouteList.includes(item.journey)) {
                        // Identifica o índice na lista de selecionadas
                        let indexOf = this.selectedJourneyWithRouteList.indexOf(item.journey);
                        // Identifica a posição na lista
                        if(indexOf !== false) {
                            // Remove a posição das listas
                            this.selectedJourneyWithRouteList.splice(indexOf, 1);
                        }
                    }

                    // Atualiza a lista de pontos
                    item.journey.points = nodes;

                    // Atualiza informações
                    item.journey.totalDelivery = 0;
                    item.journey.totalDistance = 0;
                    item.journey.totalWeight = 0;
                    item.journey.totalTime = 0;

                    // Adiciona a lista de veículos sem rotas
                    this.journeyWithoutRouteList.push(item.journey);
                }
            }
        },
        
        /**
         * Atualiza as informações das entregas
         * @param {array} nodes array com as entregas
         **/
        updateNodes: function(nodes) {
            // Pecorre a lista de entregas da edição
            nodes.map(point => {
                // Verifica se é centro de distribuição
                if(!point.isDC) {
                    let indexOF = false;
                    
                    // Verifica se a entrega estava na lista de desvinculadas
                    this.droppedNodesList.map((dropped, index) => {
                        if(point.documentIdentifier == dropped.documentIdentifier) indexOF = index;
                    });
                    
                    // Identifica a posição na lista
                    if(indexOF !== false) {
                        // Remove a posição das listas
                        this.droppedNodesList.splice(indexOF, 1);

                        // Remove o marcador do mapa
                        if(this.layerGroupDroppedNode.hasLayer(this.markerDroppedNodeList[indexOF])) {
                            this.layerGroupDroppedNode.removeLayer(this.markerDroppedNodeList[indexOF]);
                        }

                        // Remove da a lista de marcadores das entregas desvinculadas
                        this.markerDroppedNodeList.splice(indexOF, 1);
                    }

                    indexOF = false;

                    // Verifica se a entrega estava na lista de desvinculadas selecionadas
                    this.selectedDroppedNodesList.map((selected, index) => {
                        if(point.documentIdentifier == selected.documentIdentifier) indexOF = index;
                    });
                    
                    // Identifica a posição na lista
                    if(indexOF !== false) {
                        // Remove a posição das listas
                        this.selectedDroppedNodesList.splice(indexOF, 1);
                    }
                }
            });
            
            // Verifica se há dropped nodes
            if(this.layerGroupDroppedNode != null) {
                // Limpa os marcadores do mapa
                this.layerGroupDroppedNode.clearLayers();
            }

            // Adiciona a lista de marcadores em uma layer group e a adiciona ao mapa
            this.layerGroupDroppedNode = L.layerGroup(this.markerDroppedNodeList).addTo(this.map);
        },

        /**
         * Atualiza as informações das entregas desvinculadas
         * @param {array} droppedNodes array com as entregas desvinculadas
         **/
        updateDroppedNodes: function(droppedNodes) {
            // Pecorre a lista de entregas desvinculadas da edição
            droppedNodes.map((point, index) => {
                // Verifica se é centro de distribuição
                if(!point.isDC) {
                    let indexOF = false;
                    
                    // Verifica se a entrega estava na lista de desvinculadas
                    this.droppedNodesList.map((dropped, index) => {
                        if(point.documentIdentifier == dropped.documentIdentifier) indexOF = index;
                    });
                    
                    // Verifica se não existe na lista
                    if(indexOF === false) {
                        // Adiciona as listas
                        this.droppedNodesList.push(point);
                        this.selectedDroppedNodesList.push(point);

                        // Inicia o marcador da entrega
                        let marker = null;

                        // Processa a entrega
                        marker = this.processNodeIndividual(point, "edit-" + index, false, true);

                        // Adicionar a lista de marcadores
                        this.markerDroppedNodeList.push(marker);
                    }
                }
            });
            
            // Verifica se há dropped nodes
            if(this.layerGroupDroppedNode != null) {
                // Limpa os marcadores do mapa
                this.layerGroupDroppedNode.clearLayers();
            }

            // Adiciona a lista de marcadores em uma layer group e a adiciona ao mapa
            this.layerGroupDroppedNode = L.layerGroup(this.markerDroppedNodeList).addTo(this.map);
        },
        
        /**
         * Atualiza as informações gerais
         **/
        updateGeneralInformation: function() {
            this.totalRoute = 0;
            this.totalDelivery = 0;
            this.totalDistance = 0;
            this.totalWeight = 0;
            this.totalTime = 0;
            this.totalDroppedNode = 0;

            this.totalRoute = this.journeyWithRouteList.length;
            this.journeyWithRouteList.map(journey => {
                this.totalDelivery += journey.returnOrigin ? journey.points.length - 2 : journey.points.length -1;
                this.totalDistance += journey.totalDistance;
                this.totalTime += journey.totalTime;
                this.totalWeight += journey.totalWeight;
            });
            this.totalDroppedNode = this.droppedNodesList.length;
        },
        
        /**
         * Valida as informações do veículo
         * @param {object} journey informações da rota
         * @param {boolean} withRoute inica se tem rota
         * @return {object} informações do veículo
         **/
        validationVehicle: function(journey, withRoute) {    
            let startLunchTime = journey.startLunchTime.split(":");
            let endLunchTime = journey.endLunchTime.split(":");

            let vehicle = {
                vehicle_id: journey.vehicleID,
                vehicle_license_plate: journey.vehicleLicensePlate,
                vehicle_brand: journey.vehicleBrand,
                vehicle_type: journey.vehicleType,
                vehicle_bodywork: journey.vehicleBodywork,
                vehicle_weight_capacity: journey.vehicleWeightCapacity,
                
                lunch_time: journey.lunchTime ? journey.lunchTime : "",
                start_lunch_time: journey.startLunchTime ? startLunchTime[0] + ":" + startLunchTime[1] + ":00" : "",
                end_lunch_time: journey.endLunchTime ? endLunchTime[0] + ":" + endLunchTime[1] + ":00" : "",
                start_lunch_time_route: journey.startLunchTimeRoute ? journey.startLunchTimeRoute : "",
                end_lunch_time_route: journey.endLunchTimeRoute ? journey.endLunchTimeRoute : "",
                average_speed: journey.averageSpeed ? journey.averageSpeed : "",
                discharge_weight_per_minut: journey.dischargeWeightPerMinut ? journey.dischargeWeightPerMinut : "",
                return_origin: journey.returnOrigin ? 1 : 0,

                total_delivery: journey.totalDelivery,
                total_distance: journey.totalDistance,
                total_weight: journey.totalWeight,
                
                weight_constraint: journey.weightConstraints ? 1 : 0,
                time_constraint: journey.timeConstraints ? 1 : 0,
                
                driver_name: "",
                driver_document: "",
            }
            
            // Verifica o motorista da rota
            //if((parseInt(journey.totalWeight) > 0) && this.$refs.route["$refs"].driverDocument[index] && (this.$refs.route["$refs"].driverDocument[index].value != "")) {
            if(journey.driverDocument != "") {
                // Percorre a lista de motoristas
                this.my_drivers.map(driver => {
                    // Verifica se é o id do motorisa
                    //if(parseInt(this.$refs.route["$refs"].driverDocument[index].value) == driver.document) {
                    if(journey.driverDocument == driver.document) {
                        // Adiciona as informações no veículo
                        vehicle.driver_name = driver.name;
                        vehicle.driver_document = driver.document;
                        
                        if(withRoute) {
                            // Verifica se está na lista dos motoristas com rotas
                            if(this.driverWithRoute.includes(driver)) {
                                this.driverMoreThanOneRoute.push(driver);
                            } else {
                                this.driverWithRoute.push(driver);
                            }
                        }
                    }
                });
            }

            return vehicle;
        },

        /**
         * Valida as informações dos pontos
         * @param {array} list lista de pontos
         * @return {array} lista de pontos dessa rota
         **/
        validationNodes: function(list) {
            let nodeList = [];

            list.map((point, index) => {
                let startTime = point.startTime.split(":");
                let endTime = point.endTime.split(":");

                let node = {
                    is_dropped: 0,

                    is_dc: point.isDC ? 1 : 0,
                    dc_name: point.dcName ? point.dcName : "",
                    
                    customer_id: point.customerID,
                    customer_name: point.customerName ? point.customerName : "",
                    customer_document: point.customerDocument ? point.customerDocument : "",
                    customer_code: point.customerCode ? point.customerCode : "",

                    delivery_code: point.documentCode ? point.documentCode : "",
                    delivery_moviment_type_code: point.movimentTypeCode ? point.movimentTypeCode : null,
                    delivery_document_identifier: point.documentIdentifier ? point.documentIdentifier : "",
                    delivery_document_number: point.documentNumber ? point.documentNumber : "",
                    delivery_weight: point.weight ? point.weight : "",
                    
                    start_time: point.startTime ? startTime[0] + ":" + startTime[1] + ":00" : "00:00:00",
                    end_time: point.endTime ? endTime[0] + ":" + endTime[1] + ":00": "00:00:00",
                    start_time_route: point.startTimeRoute ? point.startTimeRoute : "00:00:00",
                    end_time_route: point.endTimeRoute ? point.endTimeRoute : "00:00:00",
                    
                    average_discharge_time: point.averageDischargeTime ? point.averageDischargeTime : "",
                    discharge_weight_per_minut: point.dischargeWeightPerMinut ? point.dischargeWeightPerMinut : "",
                    average_waiting_time: point.averageWaitingTime ? point.averageWaitingTime : "",

                    distance_between: point.distanceBetween ? point.distanceBetween : "",
                    time_between: point.timeBetween ? point.timeBetween : "",

                    sequence: point.sequence ? point.sequence : (point.isDC ? index : ""),
                    package_sequence: point.packageSequence ? point.packageSequence : "",

                    address_id: point.addressID,
                }

                nodeList.push(node);
            });
            
            return nodeList
        },

        /**
         * Valida as informações dos pontos
         * @param {array} list lista de pontos
         * @return {array} lista de pontos dessa rota
         **/
        validationDroppedNodes: function(list) {
            let nodeList = [];

            list.map(point => {
                let startTime = point.startTime.split(":");
                let endTime = point.endTime.split(":");

                let node = {
                    is_dropped: 1,

                    is_dc: 0,
                    dc_name: "",
                    
                    customer_id: point.customerID,
                    customer_name: point.customerName ? point.customerName : "",
                    customer_document: point.customerDocument ? point.customerDocument : "",
                    customer_code: point.customerCode ? point.customerCode : "",
                    
                    delivery_code: point.documentCode ? point.documentCode : "",
                    delivery_moviment_type_code: point.movimentTypeCode ? point.movimentTypeCode : null,
                    delivery_document_identifier: point.documentIdentifier ? point.documentIdentifier : "",
                    delivery_document_number: point.documentNumber ? point.documentNumber : "",
                    delivery_weight: point.weight ? point.weight : "",
                   
                    start_time: point.startTime ? startTime[0] + ":" + startTime[1] + ":00" : "00:00:00",
                    end_time: point.endTime ? endTime[0] + ":" + endTime[1] + ":00" : "00:00:00",

                    average_discharge_time: point.averageDischargeTime ? point.averageDischargeTime : "",
                    discharge_weight_per_minut: point.dischargeWeightPerMinut ? point.dischargeWeightPerMinut : "",
                    average_waiting_time: point.averageWaitingTime ? point.averageWaitingTime : "",

                    address_id: point.addressID,
                }

                nodeList.push(node);
            });
            
            return nodeList
        },

        /**
         * Valida as informação das rotas geradas
         **/ 
        validation: function() {
            this.driverWithRoute = [];
            this.driverMoreThanOneRoute = [];

            let error = false;
            
            let deliveryRouting = {
                id: 0, 
                name: "",
                date: "",
                cargo: "",
                
                start_time: "00:00:00",
                end_time: "00:00:00",
                lunch_time: 0,
                start_lunch_time: "00:00:00",
                end_lunch_time: "00:00:00",
                average_speed: 0,
                average_discharge_time: 0,
                discharge_weight_per_minut: 0,
                correction_fact: 100,

                total_route: 0,
                total_delivery: 0,
                total_distance: 0,
                total_weight: 0,

                weight_constraint: 0,
                time_constraint: 0,

                finished: 0,
                
                routes: [],
                dropped_nodes: [],
            };

            let startTime = this.data.base.startTime.split(":");
            let endTime = this.data.base.endTime.split(":");
            let startLunchTime = this.data.base.startLunchTime.split(":");
            let endLunchTime = this.data.base.endLunchTime.split(":");
            
            deliveryRouting.id = this.data.result.id;
            deliveryRouting.name = this.data.base.name;
            deliveryRouting.date = this.getDateToSave(this.data.base.date);

            deliveryRouting.start_time = startTime[0] + ":" + startTime[1] + ":00";
            deliveryRouting.end_time = endTime[0] + ":" + endTime[1] + ":00";
            deliveryRouting.start_lunch_time = startLunchTime[0] + ":" + startLunchTime[1] + ":00";
            deliveryRouting.end_lunch_time = endLunchTime[0] + ":" + endLunchTime[1] + ":00";
            deliveryRouting.lunch_time = this.data.base.lunchTime;

            deliveryRouting.average_speed = this.data.base.averageSpeed;
            deliveryRouting.average_discharge_time = this.data.base.averageDischargeTime;
            deliveryRouting.discharge_weight_per_minut = this.data.base.dischargeWeightPerMinut;
            deliveryRouting.correction_fact = this.data.base.correctionFact;

            deliveryRouting.weight_constraint = this.data.result.weightConstraints ? 1 : 0;
            deliveryRouting.time_constraint = this.data.result.timeConstraints ? 1 : 0;

            deliveryRouting.total_route = this.totalRoute;
            deliveryRouting.total_delivery = this.totalDelivery;
            deliveryRouting.total_distance = this.totalDistance;
            deliveryRouting.total_weight = this.totalWeight;
            
            if(this.journeyWithRouteList.length > 0) {
                //this.journeyWithRouteList.map((j, index) => {
                this.journeyWithRouteList.map((j) => {
                    //let vehicle = this.validationVehicle(j, index);
                    let vehicle = this.validationVehicle(j, true);
                    let nodesList = this.validationNodes(j.points);
                    deliveryRouting.routes.push({vehicle, nodesList});
                });
            } else {
                this.$notification.error("Não há rotas geradas.");
                error = true;
            }

            if(this.journeyWithoutRouteList.length > 0) {
                //this.journeyWithoutRouteList.map((j, index) => {
                this.journeyWithoutRouteList.map((j) => {
                    //let vehicle = this.validationVehicle(j, index);
                    let vehicle = this.validationVehicle(j, false);
                    let nodesList = this.validationNodes(j.points);
                    deliveryRouting.routes.push({vehicle, nodesList});
                });
            }

            if(this.droppedNodesList.length > 0) {
                let droppedNodesList = this.validationDroppedNodes(this.droppedNodesList);
                deliveryRouting.dropped_nodes = droppedNodesList;
            }

            if(this.driverMoreThanOneRoute.length > 0) {
                this.driverMoreThanOneRoute.map(d => {
                    this.$notification.error("Motorista, " + d.name + ", está selecionado para mais de uma rota no mesmo período.");
                });
                error = true;
            }
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return deliveryRouting;
            }
        },
        
        authenticate: async function() {
            // Verifica se tem sessão
			let auth = null;
            try {
                auth = await Api.get("auth/authenticated");
            } catch(ex) {
                console.log(ex);
                return false;
            }
            
            // Verifica se foi retornado
            if(auth) {
                if(auth.error) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },

        /**
         * Salva as rotas geradas
         **/
        save: async function() {
            // Verifica se tem sessão
			let auth = await this.authenticate();
            
            // Verifica se foi retornado
            if (auth) {
                // Solicita a validação
                let form = this.validation();

                // Verifica o resultado da validação
                if(form == null) {
                    return;
                }
                
                // Requisita o salvamento
                let result = null;
                this.loading = true;
                try {
                    result = await Api.post("delivery-routing/save", form);
                } catch(ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível salvar o roteiro.");
                    this.loading = false;
                    return;
                }
                this.loading = false;
                
                if(result) {
                    // Verifica o resultado da requisição
                    if(result.error) {
                        if (result.data == "unauthorized") {
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => { 
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            // Se tiver erro exibe as mensagens
                            for(let i = 0; i < result.data.length; i++) {
                                this.$notification.error(result.data[i]);
                            }
                            return;
                        }
                    } else {
                        // Senão houver exibe o sucesso
                        this.$notification.success("Roteiro salvo com sucesso.");
                        
                        // Obtem o id resultante
                        this.data.result.id = result.data.id;
                        this.data.base.id = result.data.id;
                        this.data.base.created_at = result.data.created_at;
                        this.data.base.updated_at = result.data.updated_at;
                        
                        // Informa que já foi salvo
                        this.saved = true;
                        return;
                    }
                } else {
                    this.$notification.error("Não foi possível salvar o roteiro.");
                    return;
                }
            } else {
                this.$notification.error("Desculpe, sua sessão expirou.");
                setTimeout(() => { 
                    Api.logout();
                    return;
                }, 2000);
            }
		},
        
        /**
         * Salva as rotas geradas
         **/
        finish: async function() {
            // Verifica se tem sessão
			let auth = this.authenticate();
            
            // Verifica se foi retornado
            if (auth) {
                // Solicita a validação
                let form = this.validation();

                // Verifica o resultado da validação
                if(form == null) {
                    return;
                }
                
                // Apresenta a confirmação
                let confirm = await this.$alert.confirm("As rotas geradas serão salvas e suas entregas atribuidas as cargas do roteiro do dia " + this.getDate(this.data.base.date) + ". Deseja continuar?", "AVISO");
                if(!confirm) {
                    return;
                }
                
                // Verifica se quer gerar carga
                if ((typeof this.my_settings.generate_cargo !== "undefined") && (this.my_settings.generate_cargo == "0")) {
                    let cargo = false;
                    let keep = true;
                    do {
                        cargo = await this.$alert.prompt("Informe o CÓDIGO que deseja para as cargas desse roteiro", "Novo código", {
                            placeholder: "Ex.: C001",
                            type: "text"
                        });
                        if (cargo) {
                            if ((cargo.length >= 3) && (cargo.length <= 8)) {
                                keep = false;
                                form.cargo = cargo.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(" ", "_");
                            } else {
                                this.$notification.error("O CÓDIGO da carga deve ter no mínimo 3 e no máximo 8 caracteres.");
                            }
                        } else {
                            if (cargo === false) {
                                confirm = await this.$alert.confirm("O CÓDIGO da carga será gerado AUTOMATICAMENTE. Deseja continuar?", "AVISO");
                                if (confirm) {
                                    keep = false;
                                }
                            }
                        }
                    } while (keep);
                }

                // Define que está finalizado
                form.finished = 1;
                
                // Requisita o salvamento
                let result = null;
                this.loading = true;
                try {
                    result = await Api.post("delivery-routing/save", form);
                } catch(ex) {
                    this.loading = false;

                    console.log(ex);
                    this.$notification.error("Não foi possível finalizar o roteiro.");
                    return;
                }
                this.loading = false;
                
                if(result) {
                    // Verifica o resultado da requisição
                    if(result.error) {
                        if (result.data == "unauthorized") {
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => { 
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            // Se tiver erro exibe as mensagens
                            for(let i = 0; i < result.data.length; i++) {
                                this.$notification.error(result.data[i]);
                            }
                            return;
                        }
                    } else {
                        // Senão houver exibe o sucesso
                        this.$notification.success("Roteiro finalizado com sucesso.");
                        
                        // Obtem o id resultante
                        this.data.result.id = result.data.id;
                        this.data.base.id = result.data.id;
                        this.data.base.created_at = result.data.created_at;
                        this.data.base.updated_at = result.data.updated_at;
                        
                        // Informa que foi salvo
                        this.saved = true;

                        // Informa que foi finalizado
                        this.finished = true;

                        // Verifica se é cliente Atak
                        if(this.client_atak) {
                            // Apresenta a confirmação
                            let confirm = await this.$alert.confirm("Deseja SINCRONIZAR as cargas geradas com o seu sistema integrado?", "AVISO");
                            if(!confirm) {
                                return;
                            }

                            // Envia as cargas geradas para o sistema integrado
                            this.showSynchronizationAtak({
                                id: this.data.base.id,
                                name: this.data.base.name,
                                date: this.getDateToSave(this.data.base.date),
                                created_at: this.data.base.created_at,
                                updated_at: this.data.base.updated_at,
                            });
                        }
                    }
                } else {
                    this.$notification.error("Não foi possível finalizar o roteiro.");
                    return;
                }
            } else {
                this.$notification.error("Desculpe, sua sessão expirou.");
                setTimeout(() => { 
                    Api.logout();
                    return;
                }, 2000);
            }
		},

        /**
         * Exibe o modal de exportação do roteiro selecionado
         * @param {object} item objeto com informações do roteiro atual
         */
        showSynchronizationAtak: function(item) {
            this.current = item;
            this.showModalSynchronizationAtak = true;
        },

        /**
         * Limpa as informações sobre o roteiro selecionado e fecha o modal de sincronização de cargas
         */
         closeSynchronizationAtak: function() {
            this.showModalSynchronizationAtak = false;
            this.current = null;
        },

        /**
         * Muda a view para o form de roteiro
         **/
         cancel: async function() {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo cancelar?", "CANCELAR");

            // Verifica se para remover
            if(!confirm) return;

            this.$emit("update", []);
            this.$emit("view", "list");
        },
        
        /**
         * Volta pra tela de listagem
         **/
        back: function() {
            this.$emit("update", []);
            this.$emit("view", "list");
        },
    }
}
</script>

<style scoped>
.container-top {
    padding: 0px 30px;
}

.map {
    position: static;
    width: 100%;
	/*height: 100vh;*/
	height: calc(100vh - 200px);
    /*border: 1px solid #595959;*/
    border: none;
    border-radius: 4px;
    z-index: 0;
    /*margin-top: -425px;*/
}

.container-itinerary {
    width: 400px;
    position: relative;
    margin-top: 15px;
    margin-left: 15px;
    z-index: 2;
}

.container-map {
    margin-bottom: 15px;
}

.container-route, 
.container-dropped {
    margin-bottom: 15px;
}

.container-collapse-header {
    padding: 15px 15px;
    /*background-color: #a6a6a6;*/
    background-color: #fff;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    cursor: pointer;
    /*color: #000;*/
}

.container-button {
    margin-top: 15px;
}

span.collapse-header-arrow {
    float: right;
}

.container-collapse-body {
    /*margin-bottom: 15px;*/
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #fff;
}

.container-point {
    overflow-y: auto;
}

.point-feedback {
    padding: 0px 10px 10px;
    background-color: #fff;
    font-size: 12px;
    text-align: right;
}

.title {
    margin: 0px;
}

.subtitle {
    margin: 0px;
}

.collapsible-button {
    background-color: #777;
    color: white;
    cursor: pointer;
    padding: 15px;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 12px;
}

.active, .collapsible:hover {
    background-color: #555;
}

.collapsible-content {
    padding: 0 15px;
    display: none;
    overflow: hidden;
    background-color: #f1f1f1;
    border: 1px solid #000;
}

ul.point-list {
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    list-style-type: none;
}

ul.point-list > li.point-list-item {
    padding: 5px;
    border: 1px solid transparent;
}

ul.point-list > li.point-list-item:nth-of-type(odd) {
    background-color: #f5f5f5;
}

ul.point-list > li.point-list-item:hover {
    background-color: #eeeeee;
    cursor: pointer;
    border: 1px solid #eeeeee;
    border-top: 1px solid #595959;
    border-bottom: 1px solid #595959;
}

ul.point-list > li.point-list-item > p {
    font-size: 11px;
    margin: 0px;
}

ul.point-list > li.point-list-item > p.point-list-item-dc-title {
    margin-bottom: 10px;
}

ul.point-list > li.point-list-item > p.point-list-item-point-title {
    margin-bottom: 10px;
}

ul.point-list > li.point-list-item > p > span.point-list-item-point-checkbox {
    float: right;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

.button-cancel {
    color: #595959;
    background-color: #d9d9d9;
}

.button-finish {
    float: right;
}
</style>